/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OfficeRouteImport } from './routes/_office'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as WorkspaceRouteImport } from './routes/_workspace'
import { Route as SiteCoworldRouteImport } from './routes/_site.$coworld'
import { Route as SiteAccountRouteImport } from './routes/_site.account'
import { Route as SiteBrowseRouteImport } from './routes/_site.browse'
import { Route as SiteCompleteProfileRouteImport } from './routes/_site.complete-profile'
import { Route as SiteCoworldsRouteImport } from './routes/_site.coworlds'
import { Route as SiteGetStartedRouteImport } from './routes/_site.get-started'
import { Route as SitePoliciesRouteImport } from './routes/_site.policies'
import { Route as SiteSearchRouteImport } from './routes/_site.search'
import { Route as SiteSignInRouteImport } from './routes/_site.sign-in'
import { Route as SiteWatchRouteImport } from './routes/_site.watch'
import { Route as WorkspaceIdeNextRouteImport } from './routes/_workspace.ide-next'
import { Route as SiteCoworldIndexRouteImport } from './routes/_site.$coworld.index'
import { Route as SiteCoworldLeagueRouteImport } from './routes/_site.$coworld.$league'
import { Route as SiteCoworldDeskRouteImport } from './routes/_site.$coworld.desk'
import { Route as SiteCoworldPlayRouteImport } from './routes/_site.$coworld.play'
import { Route as SiteCoworldPreviewRouteImport } from './routes/_site.$coworld.preview'
import { Route as SiteCoworldSearchRouteImport } from './routes/_site.$coworld.search'
import { Route as SiteCoworldStartRouteImport } from './routes/_site.$coworld.start'
import { Route as SiteCoworldSubmitRouteImport } from './routes/_site.$coworld.submit'
import { Route as SiteAccountIndexRouteImport } from './routes/_site.account.index'
import { Route as SiteAccountAdvancedRouteImport } from './routes/_site.account.advanced'
import { Route as SiteAccountCredentialsRouteImport } from './routes/_site.account.credentials'
import { Route as SiteCliAuthIndexRouteImport } from './routes/_site.cli-auth.index'
import { Route as SiteCliAuthCompleteRouteImport } from './routes/_site.cli-auth.complete'
import { Route as SiteCoworldsIndexRouteImport } from './routes/_site.coworlds.index'
import { Route as SiteEpisodesEpisodeIdRouteImport } from './routes/_site.episodes.$episodeId'
import { Route as SiteExperienceRequestsRequestIdRouteImport } from './routes/_site.experience-requests.$requestId'
import { Route as SiteForumIndexRouteImport } from './routes/_site.forum.index'
import { Route as SiteForumPostIdRouteImport } from './routes/_site.forum.$postId'
import { Route as SiteGithubConnectRouteImport } from './routes/_site.github.connect'
import { Route as SiteLobbiesLobbyIdRouteImport } from './routes/_site.lobbies.$lobbyId'
import { Route as SitePlaySessionsSessionIdRouteImport } from './routes/_site.play-sessions.$sessionId'
import { Route as SitePlayIndexRouteImport } from './routes/_site.play.index'
import { Route as SitePlaySplatRouteImport } from './routes/_site.play_.$'
import { Route as SitePlayersPlayerIdRouteImport } from './routes/_site.players.$playerId'
import { Route as SitePoliciesIndexRouteImport } from './routes/_site.policies.index'
import { Route as SitePoliciesPolicyIdRouteImport } from './routes/_site.policies.$policyId'
import { Route as SitePreviewSplatRouteImport } from './routes/_site.preview.$'
import { Route as SiteReplaysCoworldIdRouteImport } from './routes/_site.replays.$coworldId'
import { Route as SiteTournamentsTournamentIdRouteImport } from './routes/_site.tournaments.$tournamentId'
import { Route as SiteUnlistedCoworldRouteImport } from './routes/_site.unlisted.$coworld'
import { Route as SiteWikiIndexRouteImport } from './routes/_site.wiki.index'
import { Route as SiteWikiSplatRouteImport } from './routes/_site.wiki.$'
import { Route as WorkspaceIdeNextIndexRouteImport } from './routes/_workspace.ide-next.index'
import { Route as OfficeUnlistedOfficeBeltholderRouteImport } from './routes/_office.unlisted.office.beltholder'
import { Route as OfficeUnlistedOfficeCampaignBoardRouteImport } from './routes/_office.unlisted.office.campaign-board'
import { Route as OfficeUnlistedOfficeCoworldGrowthRouteImport } from './routes/_office.unlisted.office.coworld-growth'
import { Route as SiteCoworldLeagueIndexRouteImport } from './routes/_site.$coworld.$league.index'
import { Route as SiteCoworldLeaguePlayRouteImport } from './routes/_site.$coworld.$league.play'
import { Route as SiteCoworldLeaguePreviewRouteImport } from './routes/_site.$coworld.$league.preview'
import { Route as SiteCoworldLeagueStartRouteImport } from './routes/_site.$coworld.$league.start'
import { Route as SiteCoworldLeagueSubmitRouteImport } from './routes/_site.$coworld.$league.submit'
import { Route as SiteCoworldForumIndexRouteImport } from './routes/_site.$coworld.forum.index'
import { Route as SiteCoworldForumPostIdRouteImport } from './routes/_site.$coworld.forum.$postId'
import { Route as SiteCoworldPlayActivityRouteImport } from './routes/_site.$coworld.play_.activity'
import { Route as SiteCoworldPlayEpisodesRouteImport } from './routes/_site.$coworld.play_.episodes'
import { Route as SiteCoworldPlayRequestsRouteImport } from './routes/_site.$coworld.play_.requests'
import { Route as SiteCoworldPreviewEditRouteImport } from './routes/_site.$coworld.preview_.edit'
import { Route as SiteCoworldWikiIndexRouteImport } from './routes/_site.$coworld.wiki.index'
import { Route as SiteCoworldWikiSplatRouteImport } from './routes/_site.$coworld.wiki.$'
import { Route as SiteCoworldEpisodesEpisodeIdRouteImport } from './routes/_site.$coworld_.episodes.$episodeId'
import { Route as SiteCoworldLobbiesLobbyIdRouteImport } from './routes/_site.$coworld_.lobbies.$lobbyId'
import { Route as SiteCoworldPlaySessionsSessionIdRouteImport } from './routes/_site.$coworld_.play-sessions.$sessionId'
import { Route as SiteCoworldReportsReportSlugRouteImport } from './routes/_site.$coworld_.reports.$reportSlug'
import { Route as SiteCoworldsNameIndexRouteImport } from './routes/_site.coworlds.$name.index'
import { Route as SiteCoworldsNameManageRouteImport } from './routes/_site.coworlds.$name.manage'
import { Route as SiteCoworldsNameRunsRouteImport } from './routes/_site.coworlds.$name.runs'
import { Route as SiteEpisodeRequestsRequestIdWatchRouteImport } from './routes/_site.episode-requests.$requestId.watch'
import { Route as SiteLeaguesLeagueIdSettingsRouteImport } from './routes/_site.leagues.$leagueId.settings'
import { Route as SitePoliciesVersionsPolicyVersionIdRouteImport } from './routes/_site.policies.versions.$policyVersionId'
import { Route as SiteUnlistedCoworldIndexRouteImport } from './routes/_site.unlisted.$coworld.index'
import { Route as SiteUnlistedCoworldLeagueRouteImport } from './routes/_site.unlisted.$coworld.$league'
import { Route as SiteUnlistedCoworldDeskRouteImport } from './routes/_site.unlisted.$coworld.desk'
import { Route as SiteUnlistedCoworldPlayRouteImport } from './routes/_site.unlisted.$coworld.play'
import { Route as SiteUnlistedCoworldPreviewRouteImport } from './routes/_site.unlisted.$coworld.preview'
import { Route as SiteUnlistedCoworldSearchRouteImport } from './routes/_site.unlisted.$coworld.search'
import { Route as SiteUnlistedCoworldStartRouteImport } from './routes/_site.unlisted.$coworld.start'
import { Route as SiteUnlistedCoworldSubmitRouteImport } from './routes/_site.unlisted.$coworld.submit'
import { Route as WorkspaceIdeNextSSessionIdRouteImport } from './routes/_workspace.ide-next.s.$sessionId'
import { Route as SiteCoworldLeaguePlayActivityRouteImport } from './routes/_site.$coworld.$league.play_.activity'
import { Route as SiteCoworldLeaguePlayEpisodesRouteImport } from './routes/_site.$coworld.$league.play_.episodes'
import { Route as SiteCoworldLeaguePlayRequestsRouteImport } from './routes/_site.$coworld.$league.play_.requests'
import { Route as SiteCoworldEpisodeRequestsRequestIdWatchRouteImport } from './routes/_site.$coworld_.episode-requests.$requestId.watch'
import { Route as SiteCoworldEpisodesEpisodeIdReplayRouteImport } from './routes/_site.$coworld_.episodes.$episodeId_.replay'
import { Route as SiteCoworldsNameRunsRequestIdRouteImport } from './routes/_site.coworlds.$name.runs.$requestId'
import { Route as SiteCoworldsNameRunsNewRouteImport } from './routes/_site.coworlds.$name.runs.new'
import { Route as SiteUnlistedCoworldLeagueIndexRouteImport } from './routes/_site.unlisted.$coworld.$league.index'
import { Route as SiteUnlistedCoworldLeaguePlayRouteImport } from './routes/_site.unlisted.$coworld.$league.play'
import { Route as SiteUnlistedCoworldLeaguePreviewRouteImport } from './routes/_site.unlisted.$coworld.$league.preview'
import { Route as SiteUnlistedCoworldLeagueStartRouteImport } from './routes/_site.unlisted.$coworld.$league.start'
import { Route as SiteUnlistedCoworldLeagueSubmitRouteImport } from './routes/_site.unlisted.$coworld.$league.submit'
import { Route as SiteUnlistedCoworldForumIndexRouteImport } from './routes/_site.unlisted.$coworld.forum.index'
import { Route as SiteUnlistedCoworldForumPostIdRouteImport } from './routes/_site.unlisted.$coworld.forum.$postId'
import { Route as SiteUnlistedCoworldPlayActivityRouteImport } from './routes/_site.unlisted.$coworld.play_.activity'
import { Route as SiteUnlistedCoworldPlayEpisodesRouteImport } from './routes/_site.unlisted.$coworld.play_.episodes'
import { Route as SiteUnlistedCoworldPlayRequestsRouteImport } from './routes/_site.unlisted.$coworld.play_.requests'
import { Route as SiteUnlistedCoworldPreviewEditRouteImport } from './routes/_site.unlisted.$coworld.preview_.edit'
import { Route as SiteUnlistedCoworldWikiIndexRouteImport } from './routes/_site.unlisted.$coworld.wiki.index'
import { Route as SiteUnlistedCoworldWikiSplatRouteImport } from './routes/_site.unlisted.$coworld.wiki.$'
import { Route as SiteUnlistedCoworldEpisodesEpisodeIdRouteImport } from './routes/_site.unlisted.$coworld_.episodes.$episodeId'
import { Route as SiteUnlistedCoworldLobbiesLobbyIdRouteImport } from './routes/_site.unlisted.$coworld_.lobbies.$lobbyId'
import { Route as SiteUnlistedCoworldPlaySessionsSessionIdRouteImport } from './routes/_site.unlisted.$coworld_.play-sessions.$sessionId'
import { Route as SiteUnlistedCoworldReportsReportSlugRouteImport } from './routes/_site.unlisted.$coworld_.reports.$reportSlug'
import { Route as SiteUnlistedCoworldLeaguePlayActivityRouteImport } from './routes/_site.unlisted.$coworld.$league.play_.activity'
import { Route as SiteUnlistedCoworldLeaguePlayEpisodesRouteImport } from './routes/_site.unlisted.$coworld.$league.play_.episodes'
import { Route as SiteUnlistedCoworldLeaguePlayRequestsRouteImport } from './routes/_site.unlisted.$coworld.$league.play_.requests'
import { Route as SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRouteImport } from './routes/_site.unlisted.$coworld_.episode-requests.$requestId.watch'
import { Route as SiteUnlistedCoworldEpisodesEpisodeIdReplayRouteImport } from './routes/_site.unlisted.$coworld_.episodes.$episodeId_.replay'

const OfficeRoute = OfficeRouteImport.update({
  id: '/_office',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteRoute = SiteRouteImport.update({
  id: '/_site',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteCoworldRoute = SiteCoworldRouteImport.update({
  id: '/$coworld',
  path: '/$coworld',
  getParentRoute: () => SiteRoute,
} as any)
const SiteAccountRoute = SiteAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SiteRoute,
} as any)
const SiteBrowseRoute = SiteBrowseRouteImport.update({
  id: '/browse',
  path: '/browse',
  getParentRoute: () => SiteRoute,
} as any)
const SiteCompleteProfileRoute = SiteCompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => SiteRoute,
} as any)
const SiteCoworldsRoute = SiteCoworldsRouteImport.update({
  id: '/coworlds',
  path: '/coworlds',
  getParentRoute: () => SiteRoute,
} as any)
const SiteGetStartedRoute = SiteGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => SiteRoute,
} as any)
const SitePoliciesRoute = SitePoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => SiteRoute,
} as any)
const SiteSearchRoute = SiteSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => SiteRoute,
} as any)
const SiteSignInRoute = SiteSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => SiteRoute,
} as any)
const SiteWatchRoute = SiteWatchRouteImport.update({
  id: '/watch',
  path: '/watch',
  getParentRoute: () => SiteRoute,
} as any)
const WorkspaceIdeNextRoute = WorkspaceIdeNextRouteImport.update({
  id: '/ide-next',
  path: '/ide-next',
  getParentRoute: () => WorkspaceRoute,
} as any)
const SiteCoworldIndexRoute = SiteCoworldIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldLeagueRoute = SiteCoworldLeagueRouteImport.update({
  id: '/$league',
  path: '/$league',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldDeskRoute = SiteCoworldDeskRouteImport.update({
  id: '/desk',
  path: '/desk',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldPlayRoute = SiteCoworldPlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldPreviewRoute = SiteCoworldPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldSearchRoute = SiteCoworldSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldStartRoute = SiteCoworldStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldSubmitRoute = SiteCoworldSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteAccountIndexRoute = SiteAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteAccountRoute,
} as any)
const SiteAccountAdvancedRoute = SiteAccountAdvancedRouteImport.update({
  id: '/advanced',
  path: '/advanced',
  getParentRoute: () => SiteAccountRoute,
} as any)
const SiteAccountCredentialsRoute = SiteAccountCredentialsRouteImport.update({
  id: '/credentials',
  path: '/credentials',
  getParentRoute: () => SiteAccountRoute,
} as any)
const SiteCliAuthIndexRoute = SiteCliAuthIndexRouteImport.update({
  id: '/cli-auth/',
  path: '/cli-auth/',
  getParentRoute: () => SiteRoute,
} as any)
const SiteCliAuthCompleteRoute = SiteCliAuthCompleteRouteImport.update({
  id: '/cli-auth/complete',
  path: '/cli-auth/complete',
  getParentRoute: () => SiteRoute,
} as any)
const SiteCoworldsIndexRoute = SiteCoworldsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteCoworldsRoute,
} as any)
const SiteEpisodesEpisodeIdRoute = SiteEpisodesEpisodeIdRouteImport.update({
  id: '/episodes/$episodeId',
  path: '/episodes/$episodeId',
  getParentRoute: () => SiteRoute,
} as any)
const SiteExperienceRequestsRequestIdRoute =
  SiteExperienceRequestsRequestIdRouteImport.update({
    id: '/experience-requests/$requestId',
    path: '/experience-requests/$requestId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteForumIndexRoute = SiteForumIndexRouteImport.update({
  id: '/forum/',
  path: '/forum/',
  getParentRoute: () => SiteRoute,
} as any)
const SiteForumPostIdRoute = SiteForumPostIdRouteImport.update({
  id: '/forum/$postId',
  path: '/forum/$postId',
  getParentRoute: () => SiteRoute,
} as any)
const SiteGithubConnectRoute = SiteGithubConnectRouteImport.update({
  id: '/github/connect',
  path: '/github/connect',
  getParentRoute: () => SiteRoute,
} as any)
const SiteLobbiesLobbyIdRoute = SiteLobbiesLobbyIdRouteImport.update({
  id: '/lobbies/$lobbyId',
  path: '/lobbies/$lobbyId',
  getParentRoute: () => SiteRoute,
} as any)
const SitePlaySessionsSessionIdRoute =
  SitePlaySessionsSessionIdRouteImport.update({
    id: '/play-sessions/$sessionId',
    path: '/play-sessions/$sessionId',
    getParentRoute: () => SiteRoute,
  } as any)
const SitePlayIndexRoute = SitePlayIndexRouteImport.update({
  id: '/play/',
  path: '/play/',
  getParentRoute: () => SiteRoute,
} as any)
const SitePlaySplatRoute = SitePlaySplatRouteImport.update({
  id: '/play_/$',
  path: '/play/$',
  getParentRoute: () => SiteRoute,
} as any)
const SitePlayersPlayerIdRoute = SitePlayersPlayerIdRouteImport.update({
  id: '/players/$playerId',
  path: '/players/$playerId',
  getParentRoute: () => SiteRoute,
} as any)
const SitePoliciesIndexRoute = SitePoliciesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SitePoliciesRoute,
} as any)
const SitePoliciesPolicyIdRoute = SitePoliciesPolicyIdRouteImport.update({
  id: '/$policyId',
  path: '/$policyId',
  getParentRoute: () => SitePoliciesRoute,
} as any)
const SitePreviewSplatRoute = SitePreviewSplatRouteImport.update({
  id: '/preview/$',
  path: '/preview/$',
  getParentRoute: () => SiteRoute,
} as any)
const SiteReplaysCoworldIdRoute = SiteReplaysCoworldIdRouteImport.update({
  id: '/replays/$coworldId',
  path: '/replays/$coworldId',
  getParentRoute: () => SiteRoute,
} as any)
const SiteTournamentsTournamentIdRoute =
  SiteTournamentsTournamentIdRouteImport.update({
    id: '/tournaments/$tournamentId',
    path: '/tournaments/$tournamentId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteUnlistedCoworldRoute = SiteUnlistedCoworldRouteImport.update({
  id: '/unlisted/$coworld',
  path: '/unlisted/$coworld',
  getParentRoute: () => SiteRoute,
} as any)
const SiteWikiIndexRoute = SiteWikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => SiteRoute,
} as any)
const SiteWikiSplatRoute = SiteWikiSplatRouteImport.update({
  id: '/wiki/$',
  path: '/wiki/$',
  getParentRoute: () => SiteRoute,
} as any)
const WorkspaceIdeNextIndexRoute = WorkspaceIdeNextIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceIdeNextRoute,
} as any)
const OfficeUnlistedOfficeBeltholderRoute =
  OfficeUnlistedOfficeBeltholderRouteImport.update({
    id: '/unlisted/office/beltholder',
    path: '/unlisted/office/beltholder',
    getParentRoute: () => OfficeRoute,
  } as any)
const OfficeUnlistedOfficeCampaignBoardRoute =
  OfficeUnlistedOfficeCampaignBoardRouteImport.update({
    id: '/unlisted/office/campaign-board',
    path: '/unlisted/office/campaign-board',
    getParentRoute: () => OfficeRoute,
  } as any)
const OfficeUnlistedOfficeCoworldGrowthRoute =
  OfficeUnlistedOfficeCoworldGrowthRouteImport.update({
    id: '/unlisted/office/coworld-growth',
    path: '/unlisted/office/coworld-growth',
    getParentRoute: () => OfficeRoute,
  } as any)
const SiteCoworldLeagueIndexRoute = SiteCoworldLeagueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteCoworldLeagueRoute,
} as any)
const SiteCoworldLeaguePlayRoute = SiteCoworldLeaguePlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => SiteCoworldLeagueRoute,
} as any)
const SiteCoworldLeaguePreviewRoute =
  SiteCoworldLeaguePreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => SiteCoworldLeagueRoute,
  } as any)
const SiteCoworldLeagueStartRoute = SiteCoworldLeagueStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => SiteCoworldLeagueRoute,
} as any)
const SiteCoworldLeagueSubmitRoute = SiteCoworldLeagueSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => SiteCoworldLeagueRoute,
} as any)
const SiteCoworldForumIndexRoute = SiteCoworldForumIndexRouteImport.update({
  id: '/forum/',
  path: '/forum/',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldForumPostIdRoute = SiteCoworldForumPostIdRouteImport.update({
  id: '/forum/$postId',
  path: '/forum/$postId',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldPlayActivityRoute = SiteCoworldPlayActivityRouteImport.update({
  id: '/play_/activity',
  path: '/play/activity',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldPlayEpisodesRoute = SiteCoworldPlayEpisodesRouteImport.update({
  id: '/play_/episodes',
  path: '/play/episodes',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldPlayRequestsRoute = SiteCoworldPlayRequestsRouteImport.update({
  id: '/play_/requests',
  path: '/play/requests',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldPreviewEditRoute = SiteCoworldPreviewEditRouteImport.update({
  id: '/preview_/edit',
  path: '/preview/edit',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldWikiIndexRoute = SiteCoworldWikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldWikiSplatRoute = SiteCoworldWikiSplatRouteImport.update({
  id: '/wiki/$',
  path: '/wiki/$',
  getParentRoute: () => SiteCoworldRoute,
} as any)
const SiteCoworldEpisodesEpisodeIdRoute =
  SiteCoworldEpisodesEpisodeIdRouteImport.update({
    id: '/$coworld_/episodes/$episodeId',
    path: '/$coworld/episodes/$episodeId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteCoworldLobbiesLobbyIdRoute =
  SiteCoworldLobbiesLobbyIdRouteImport.update({
    id: '/$coworld_/lobbies/$lobbyId',
    path: '/$coworld/lobbies/$lobbyId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteCoworldPlaySessionsSessionIdRoute =
  SiteCoworldPlaySessionsSessionIdRouteImport.update({
    id: '/$coworld_/play-sessions/$sessionId',
    path: '/$coworld/play-sessions/$sessionId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteCoworldReportsReportSlugRoute =
  SiteCoworldReportsReportSlugRouteImport.update({
    id: '/$coworld_/reports/$reportSlug',
    path: '/$coworld/reports/$reportSlug',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteCoworldsNameIndexRoute = SiteCoworldsNameIndexRouteImport.update({
  id: '/$name/',
  path: '/$name/',
  getParentRoute: () => SiteCoworldsRoute,
} as any)
const SiteCoworldsNameManageRoute = SiteCoworldsNameManageRouteImport.update({
  id: '/$name/manage',
  path: '/$name/manage',
  getParentRoute: () => SiteCoworldsRoute,
} as any)
const SiteCoworldsNameRunsRoute = SiteCoworldsNameRunsRouteImport.update({
  id: '/$name/runs',
  path: '/$name/runs',
  getParentRoute: () => SiteCoworldsRoute,
} as any)
const SiteEpisodeRequestsRequestIdWatchRoute =
  SiteEpisodeRequestsRequestIdWatchRouteImport.update({
    id: '/episode-requests/$requestId/watch',
    path: '/episode-requests/$requestId/watch',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteLeaguesLeagueIdSettingsRoute =
  SiteLeaguesLeagueIdSettingsRouteImport.update({
    id: '/leagues/$leagueId/settings',
    path: '/leagues/$leagueId/settings',
    getParentRoute: () => SiteRoute,
  } as any)
const SitePoliciesVersionsPolicyVersionIdRoute =
  SitePoliciesVersionsPolicyVersionIdRouteImport.update({
    id: '/versions/$policyVersionId',
    path: '/versions/$policyVersionId',
    getParentRoute: () => SitePoliciesRoute,
  } as any)
const SiteUnlistedCoworldIndexRoute =
  SiteUnlistedCoworldIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldLeagueRoute =
  SiteUnlistedCoworldLeagueRouteImport.update({
    id: '/$league',
    path: '/$league',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldDeskRoute = SiteUnlistedCoworldDeskRouteImport.update({
  id: '/desk',
  path: '/desk',
  getParentRoute: () => SiteUnlistedCoworldRoute,
} as any)
const SiteUnlistedCoworldPlayRoute = SiteUnlistedCoworldPlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => SiteUnlistedCoworldRoute,
} as any)
const SiteUnlistedCoworldPreviewRoute =
  SiteUnlistedCoworldPreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldSearchRoute =
  SiteUnlistedCoworldSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldStartRoute =
  SiteUnlistedCoworldStartRouteImport.update({
    id: '/start',
    path: '/start',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldSubmitRoute =
  SiteUnlistedCoworldSubmitRouteImport.update({
    id: '/submit',
    path: '/submit',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const WorkspaceIdeNextSSessionIdRoute =
  WorkspaceIdeNextSSessionIdRouteImport.update({
    id: '/s/$sessionId',
    path: '/s/$sessionId',
    getParentRoute: () => WorkspaceIdeNextRoute,
  } as any)
const SiteCoworldLeaguePlayActivityRoute =
  SiteCoworldLeaguePlayActivityRouteImport.update({
    id: '/play_/activity',
    path: '/play/activity',
    getParentRoute: () => SiteCoworldLeagueRoute,
  } as any)
const SiteCoworldLeaguePlayEpisodesRoute =
  SiteCoworldLeaguePlayEpisodesRouteImport.update({
    id: '/play_/episodes',
    path: '/play/episodes',
    getParentRoute: () => SiteCoworldLeagueRoute,
  } as any)
const SiteCoworldLeaguePlayRequestsRoute =
  SiteCoworldLeaguePlayRequestsRouteImport.update({
    id: '/play_/requests',
    path: '/play/requests',
    getParentRoute: () => SiteCoworldLeagueRoute,
  } as any)
const SiteCoworldEpisodeRequestsRequestIdWatchRoute =
  SiteCoworldEpisodeRequestsRequestIdWatchRouteImport.update({
    id: '/$coworld_/episode-requests/$requestId/watch',
    path: '/$coworld/episode-requests/$requestId/watch',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteCoworldEpisodesEpisodeIdReplayRoute =
  SiteCoworldEpisodesEpisodeIdReplayRouteImport.update({
    id: '/$coworld_/episodes/$episodeId_/replay',
    path: '/$coworld/episodes/$episodeId/replay',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteCoworldsNameRunsRequestIdRoute =
  SiteCoworldsNameRunsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => SiteCoworldsNameRunsRoute,
  } as any)
const SiteCoworldsNameRunsNewRoute = SiteCoworldsNameRunsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SiteCoworldsNameRunsRoute,
} as any)
const SiteUnlistedCoworldLeagueIndexRoute =
  SiteUnlistedCoworldLeagueIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldLeaguePlayRoute =
  SiteUnlistedCoworldLeaguePlayRouteImport.update({
    id: '/play',
    path: '/play',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldLeaguePreviewRoute =
  SiteUnlistedCoworldLeaguePreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldLeagueStartRoute =
  SiteUnlistedCoworldLeagueStartRouteImport.update({
    id: '/start',
    path: '/start',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldLeagueSubmitRoute =
  SiteUnlistedCoworldLeagueSubmitRouteImport.update({
    id: '/submit',
    path: '/submit',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldForumIndexRoute =
  SiteUnlistedCoworldForumIndexRouteImport.update({
    id: '/forum/',
    path: '/forum/',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldForumPostIdRoute =
  SiteUnlistedCoworldForumPostIdRouteImport.update({
    id: '/forum/$postId',
    path: '/forum/$postId',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldPlayActivityRoute =
  SiteUnlistedCoworldPlayActivityRouteImport.update({
    id: '/play_/activity',
    path: '/play/activity',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldPlayEpisodesRoute =
  SiteUnlistedCoworldPlayEpisodesRouteImport.update({
    id: '/play_/episodes',
    path: '/play/episodes',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldPlayRequestsRoute =
  SiteUnlistedCoworldPlayRequestsRouteImport.update({
    id: '/play_/requests',
    path: '/play/requests',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldPreviewEditRoute =
  SiteUnlistedCoworldPreviewEditRouteImport.update({
    id: '/preview_/edit',
    path: '/preview/edit',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldWikiIndexRoute =
  SiteUnlistedCoworldWikiIndexRouteImport.update({
    id: '/wiki/',
    path: '/wiki/',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldWikiSplatRoute =
  SiteUnlistedCoworldWikiSplatRouteImport.update({
    id: '/wiki/$',
    path: '/wiki/$',
    getParentRoute: () => SiteUnlistedCoworldRoute,
  } as any)
const SiteUnlistedCoworldEpisodesEpisodeIdRoute =
  SiteUnlistedCoworldEpisodesEpisodeIdRouteImport.update({
    id: '/unlisted/$coworld_/episodes/$episodeId',
    path: '/unlisted/$coworld/episodes/$episodeId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteUnlistedCoworldLobbiesLobbyIdRoute =
  SiteUnlistedCoworldLobbiesLobbyIdRouteImport.update({
    id: '/unlisted/$coworld_/lobbies/$lobbyId',
    path: '/unlisted/$coworld/lobbies/$lobbyId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteUnlistedCoworldPlaySessionsSessionIdRoute =
  SiteUnlistedCoworldPlaySessionsSessionIdRouteImport.update({
    id: '/unlisted/$coworld_/play-sessions/$sessionId',
    path: '/unlisted/$coworld/play-sessions/$sessionId',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteUnlistedCoworldReportsReportSlugRoute =
  SiteUnlistedCoworldReportsReportSlugRouteImport.update({
    id: '/unlisted/$coworld_/reports/$reportSlug',
    path: '/unlisted/$coworld/reports/$reportSlug',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteUnlistedCoworldLeaguePlayActivityRoute =
  SiteUnlistedCoworldLeaguePlayActivityRouteImport.update({
    id: '/play_/activity',
    path: '/play/activity',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldLeaguePlayEpisodesRoute =
  SiteUnlistedCoworldLeaguePlayEpisodesRouteImport.update({
    id: '/play_/episodes',
    path: '/play/episodes',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldLeaguePlayRequestsRoute =
  SiteUnlistedCoworldLeaguePlayRequestsRouteImport.update({
    id: '/play_/requests',
    path: '/play/requests',
    getParentRoute: () => SiteUnlistedCoworldLeagueRoute,
  } as any)
const SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute =
  SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRouteImport.update({
    id: '/unlisted/$coworld_/episode-requests/$requestId/watch',
    path: '/unlisted/$coworld/episode-requests/$requestId/watch',
    getParentRoute: () => SiteRoute,
  } as any)
const SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute =
  SiteUnlistedCoworldEpisodesEpisodeIdReplayRouteImport.update({
    id: '/unlisted/$coworld_/episodes/$episodeId_/replay',
    path: '/unlisted/$coworld/episodes/$episodeId/replay',
    getParentRoute: () => SiteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof WorkspaceRouteWithChildren
  '/$coworld': typeof SiteCoworldRouteWithChildren
  '/account': typeof SiteAccountRouteWithChildren
  '/browse': typeof SiteBrowseRoute
  '/complete-profile': typeof SiteCompleteProfileRoute
  '/coworlds': typeof SiteCoworldsRouteWithChildren
  '/get-started': typeof SiteGetStartedRoute
  '/policies': typeof SitePoliciesRouteWithChildren
  '/search': typeof SiteSearchRoute
  '/sign-in': typeof SiteSignInRoute
  '/watch': typeof SiteWatchRoute
  '/ide-next': typeof WorkspaceIdeNextRouteWithChildren
  '/$coworld/$league': typeof SiteCoworldLeagueRouteWithChildren
  '/$coworld/desk': typeof SiteCoworldDeskRoute
  '/$coworld/play': typeof SiteCoworldPlayRoute
  '/$coworld/preview': typeof SiteCoworldPreviewRoute
  '/$coworld/search': typeof SiteCoworldSearchRoute
  '/$coworld/start': typeof SiteCoworldStartRoute
  '/$coworld/submit': typeof SiteCoworldSubmitRoute
  '/account/advanced': typeof SiteAccountAdvancedRoute
  '/account/credentials': typeof SiteAccountCredentialsRoute
  '/cli-auth/complete': typeof SiteCliAuthCompleteRoute
  '/episodes/$episodeId': typeof SiteEpisodesEpisodeIdRoute
  '/experience-requests/$requestId': typeof SiteExperienceRequestsRequestIdRoute
  '/forum/$postId': typeof SiteForumPostIdRoute
  '/github/connect': typeof SiteGithubConnectRoute
  '/lobbies/$lobbyId': typeof SiteLobbiesLobbyIdRoute
  '/play-sessions/$sessionId': typeof SitePlaySessionsSessionIdRoute
  '/play/$': typeof SitePlaySplatRoute
  '/players/$playerId': typeof SitePlayersPlayerIdRoute
  '/policies/$policyId': typeof SitePoliciesPolicyIdRoute
  '/preview/$': typeof SitePreviewSplatRoute
  '/replays/$coworldId': typeof SiteReplaysCoworldIdRoute
  '/tournaments/$tournamentId': typeof SiteTournamentsTournamentIdRoute
  '/unlisted/$coworld': typeof SiteUnlistedCoworldRouteWithChildren
  '/wiki/$': typeof SiteWikiSplatRoute
  '/$coworld/': typeof SiteCoworldIndexRoute
  '/account/': typeof SiteAccountIndexRoute
  '/cli-auth/': typeof SiteCliAuthIndexRoute
  '/coworlds/': typeof SiteCoworldsIndexRoute
  '/forum/': typeof SiteForumIndexRoute
  '/play/': typeof SitePlayIndexRoute
  '/policies/': typeof SitePoliciesIndexRoute
  '/wiki/': typeof SiteWikiIndexRoute
  '/ide-next/': typeof WorkspaceIdeNextIndexRoute
  '/unlisted/office/beltholder': typeof OfficeUnlistedOfficeBeltholderRoute
  '/unlisted/office/campaign-board': typeof OfficeUnlistedOfficeCampaignBoardRoute
  '/unlisted/office/coworld-growth': typeof OfficeUnlistedOfficeCoworldGrowthRoute
  '/$coworld/$league/play': typeof SiteCoworldLeaguePlayRoute
  '/$coworld/$league/preview': typeof SiteCoworldLeaguePreviewRoute
  '/$coworld/$league/start': typeof SiteCoworldLeagueStartRoute
  '/$coworld/$league/submit': typeof SiteCoworldLeagueSubmitRoute
  '/$coworld/forum/$postId': typeof SiteCoworldForumPostIdRoute
  '/$coworld/play/activity': typeof SiteCoworldPlayActivityRoute
  '/$coworld/play/episodes': typeof SiteCoworldPlayEpisodesRoute
  '/$coworld/play/requests': typeof SiteCoworldPlayRequestsRoute
  '/$coworld/preview/edit': typeof SiteCoworldPreviewEditRoute
  '/$coworld/wiki/$': typeof SiteCoworldWikiSplatRoute
  '/$coworld/episodes/$episodeId': typeof SiteCoworldEpisodesEpisodeIdRoute
  '/$coworld/lobbies/$lobbyId': typeof SiteCoworldLobbiesLobbyIdRoute
  '/$coworld/play-sessions/$sessionId': typeof SiteCoworldPlaySessionsSessionIdRoute
  '/$coworld/reports/$reportSlug': typeof SiteCoworldReportsReportSlugRoute
  '/coworlds/$name/manage': typeof SiteCoworldsNameManageRoute
  '/coworlds/$name/runs': typeof SiteCoworldsNameRunsRouteWithChildren
  '/episode-requests/$requestId/watch': typeof SiteEpisodeRequestsRequestIdWatchRoute
  '/leagues/$leagueId/settings': typeof SiteLeaguesLeagueIdSettingsRoute
  '/policies/versions/$policyVersionId': typeof SitePoliciesVersionsPolicyVersionIdRoute
  '/unlisted/$coworld/$league': typeof SiteUnlistedCoworldLeagueRouteWithChildren
  '/unlisted/$coworld/desk': typeof SiteUnlistedCoworldDeskRoute
  '/unlisted/$coworld/play': typeof SiteUnlistedCoworldPlayRoute
  '/unlisted/$coworld/preview': typeof SiteUnlistedCoworldPreviewRoute
  '/unlisted/$coworld/search': typeof SiteUnlistedCoworldSearchRoute
  '/unlisted/$coworld/start': typeof SiteUnlistedCoworldStartRoute
  '/unlisted/$coworld/submit': typeof SiteUnlistedCoworldSubmitRoute
  '/ide-next/s/$sessionId': typeof WorkspaceIdeNextSSessionIdRoute
  '/$coworld/$league/': typeof SiteCoworldLeagueIndexRoute
  '/$coworld/forum/': typeof SiteCoworldForumIndexRoute
  '/$coworld/wiki/': typeof SiteCoworldWikiIndexRoute
  '/coworlds/$name/': typeof SiteCoworldsNameIndexRoute
  '/unlisted/$coworld/': typeof SiteUnlistedCoworldIndexRoute
  '/$coworld/$league/play/activity': typeof SiteCoworldLeaguePlayActivityRoute
  '/$coworld/$league/play/episodes': typeof SiteCoworldLeaguePlayEpisodesRoute
  '/$coworld/$league/play/requests': typeof SiteCoworldLeaguePlayRequestsRoute
  '/$coworld/episode-requests/$requestId/watch': typeof SiteCoworldEpisodeRequestsRequestIdWatchRoute
  '/$coworld/episodes/$episodeId/replay': typeof SiteCoworldEpisodesEpisodeIdReplayRoute
  '/coworlds/$name/runs/$requestId': typeof SiteCoworldsNameRunsRequestIdRoute
  '/coworlds/$name/runs/new': typeof SiteCoworldsNameRunsNewRoute
  '/unlisted/$coworld/$league/play': typeof SiteUnlistedCoworldLeaguePlayRoute
  '/unlisted/$coworld/$league/preview': typeof SiteUnlistedCoworldLeaguePreviewRoute
  '/unlisted/$coworld/$league/start': typeof SiteUnlistedCoworldLeagueStartRoute
  '/unlisted/$coworld/$league/submit': typeof SiteUnlistedCoworldLeagueSubmitRoute
  '/unlisted/$coworld/forum/$postId': typeof SiteUnlistedCoworldForumPostIdRoute
  '/unlisted/$coworld/play/activity': typeof SiteUnlistedCoworldPlayActivityRoute
  '/unlisted/$coworld/play/episodes': typeof SiteUnlistedCoworldPlayEpisodesRoute
  '/unlisted/$coworld/play/requests': typeof SiteUnlistedCoworldPlayRequestsRoute
  '/unlisted/$coworld/preview/edit': typeof SiteUnlistedCoworldPreviewEditRoute
  '/unlisted/$coworld/wiki/$': typeof SiteUnlistedCoworldWikiSplatRoute
  '/unlisted/$coworld/episodes/$episodeId': typeof SiteUnlistedCoworldEpisodesEpisodeIdRoute
  '/unlisted/$coworld/lobbies/$lobbyId': typeof SiteUnlistedCoworldLobbiesLobbyIdRoute
  '/unlisted/$coworld/play-sessions/$sessionId': typeof SiteUnlistedCoworldPlaySessionsSessionIdRoute
  '/unlisted/$coworld/reports/$reportSlug': typeof SiteUnlistedCoworldReportsReportSlugRoute
  '/unlisted/$coworld/$league/': typeof SiteUnlistedCoworldLeagueIndexRoute
  '/unlisted/$coworld/forum/': typeof SiteUnlistedCoworldForumIndexRoute
  '/unlisted/$coworld/wiki/': typeof SiteUnlistedCoworldWikiIndexRoute
  '/unlisted/$coworld/$league/play/activity': typeof SiteUnlistedCoworldLeaguePlayActivityRoute
  '/unlisted/$coworld/$league/play/episodes': typeof SiteUnlistedCoworldLeaguePlayEpisodesRoute
  '/unlisted/$coworld/$league/play/requests': typeof SiteUnlistedCoworldLeaguePlayRequestsRoute
  '/unlisted/$coworld/episode-requests/$requestId/watch': typeof SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute
  '/unlisted/$coworld/episodes/$episodeId/replay': typeof SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute
}
export interface FileRoutesByTo {
  '/': typeof WorkspaceRouteWithChildren
  '/browse': typeof SiteBrowseRoute
  '/complete-profile': typeof SiteCompleteProfileRoute
  '/get-started': typeof SiteGetStartedRoute
  '/search': typeof SiteSearchRoute
  '/sign-in': typeof SiteSignInRoute
  '/watch': typeof SiteWatchRoute
  '/$coworld/desk': typeof SiteCoworldDeskRoute
  '/$coworld/play': typeof SiteCoworldPlayRoute
  '/$coworld/preview': typeof SiteCoworldPreviewRoute
  '/$coworld/search': typeof SiteCoworldSearchRoute
  '/$coworld/start': typeof SiteCoworldStartRoute
  '/$coworld/submit': typeof SiteCoworldSubmitRoute
  '/account/advanced': typeof SiteAccountAdvancedRoute
  '/account/credentials': typeof SiteAccountCredentialsRoute
  '/cli-auth/complete': typeof SiteCliAuthCompleteRoute
  '/episodes/$episodeId': typeof SiteEpisodesEpisodeIdRoute
  '/experience-requests/$requestId': typeof SiteExperienceRequestsRequestIdRoute
  '/forum/$postId': typeof SiteForumPostIdRoute
  '/github/connect': typeof SiteGithubConnectRoute
  '/lobbies/$lobbyId': typeof SiteLobbiesLobbyIdRoute
  '/play-sessions/$sessionId': typeof SitePlaySessionsSessionIdRoute
  '/play/$': typeof SitePlaySplatRoute
  '/players/$playerId': typeof SitePlayersPlayerIdRoute
  '/policies/$policyId': typeof SitePoliciesPolicyIdRoute
  '/preview/$': typeof SitePreviewSplatRoute
  '/replays/$coworldId': typeof SiteReplaysCoworldIdRoute
  '/tournaments/$tournamentId': typeof SiteTournamentsTournamentIdRoute
  '/wiki/$': typeof SiteWikiSplatRoute
  '/$coworld': typeof SiteCoworldIndexRoute
  '/account': typeof SiteAccountIndexRoute
  '/cli-auth': typeof SiteCliAuthIndexRoute
  '/coworlds': typeof SiteCoworldsIndexRoute
  '/forum': typeof SiteForumIndexRoute
  '/play': typeof SitePlayIndexRoute
  '/policies': typeof SitePoliciesIndexRoute
  '/wiki': typeof SiteWikiIndexRoute
  '/ide-next': typeof WorkspaceIdeNextIndexRoute
  '/unlisted/office/beltholder': typeof OfficeUnlistedOfficeBeltholderRoute
  '/unlisted/office/campaign-board': typeof OfficeUnlistedOfficeCampaignBoardRoute
  '/unlisted/office/coworld-growth': typeof OfficeUnlistedOfficeCoworldGrowthRoute
  '/$coworld/$league/play': typeof SiteCoworldLeaguePlayRoute
  '/$coworld/$league/preview': typeof SiteCoworldLeaguePreviewRoute
  '/$coworld/$league/start': typeof SiteCoworldLeagueStartRoute
  '/$coworld/$league/submit': typeof SiteCoworldLeagueSubmitRoute
  '/$coworld/forum/$postId': typeof SiteCoworldForumPostIdRoute
  '/$coworld/play/activity': typeof SiteCoworldPlayActivityRoute
  '/$coworld/play/episodes': typeof SiteCoworldPlayEpisodesRoute
  '/$coworld/play/requests': typeof SiteCoworldPlayRequestsRoute
  '/$coworld/preview/edit': typeof SiteCoworldPreviewEditRoute
  '/$coworld/wiki/$': typeof SiteCoworldWikiSplatRoute
  '/$coworld/episodes/$episodeId': typeof SiteCoworldEpisodesEpisodeIdRoute
  '/$coworld/lobbies/$lobbyId': typeof SiteCoworldLobbiesLobbyIdRoute
  '/$coworld/play-sessions/$sessionId': typeof SiteCoworldPlaySessionsSessionIdRoute
  '/$coworld/reports/$reportSlug': typeof SiteCoworldReportsReportSlugRoute
  '/coworlds/$name/manage': typeof SiteCoworldsNameManageRoute
  '/coworlds/$name/runs': typeof SiteCoworldsNameRunsRouteWithChildren
  '/episode-requests/$requestId/watch': typeof SiteEpisodeRequestsRequestIdWatchRoute
  '/leagues/$leagueId/settings': typeof SiteLeaguesLeagueIdSettingsRoute
  '/policies/versions/$policyVersionId': typeof SitePoliciesVersionsPolicyVersionIdRoute
  '/unlisted/$coworld/desk': typeof SiteUnlistedCoworldDeskRoute
  '/unlisted/$coworld/play': typeof SiteUnlistedCoworldPlayRoute
  '/unlisted/$coworld/preview': typeof SiteUnlistedCoworldPreviewRoute
  '/unlisted/$coworld/search': typeof SiteUnlistedCoworldSearchRoute
  '/unlisted/$coworld/start': typeof SiteUnlistedCoworldStartRoute
  '/unlisted/$coworld/submit': typeof SiteUnlistedCoworldSubmitRoute
  '/ide-next/s/$sessionId': typeof WorkspaceIdeNextSSessionIdRoute
  '/$coworld/$league': typeof SiteCoworldLeagueIndexRoute
  '/$coworld/forum': typeof SiteCoworldForumIndexRoute
  '/$coworld/wiki': typeof SiteCoworldWikiIndexRoute
  '/coworlds/$name': typeof SiteCoworldsNameIndexRoute
  '/unlisted/$coworld': typeof SiteUnlistedCoworldIndexRoute
  '/$coworld/$league/play/activity': typeof SiteCoworldLeaguePlayActivityRoute
  '/$coworld/$league/play/episodes': typeof SiteCoworldLeaguePlayEpisodesRoute
  '/$coworld/$league/play/requests': typeof SiteCoworldLeaguePlayRequestsRoute
  '/$coworld/episode-requests/$requestId/watch': typeof SiteCoworldEpisodeRequestsRequestIdWatchRoute
  '/$coworld/episodes/$episodeId/replay': typeof SiteCoworldEpisodesEpisodeIdReplayRoute
  '/coworlds/$name/runs/$requestId': typeof SiteCoworldsNameRunsRequestIdRoute
  '/coworlds/$name/runs/new': typeof SiteCoworldsNameRunsNewRoute
  '/unlisted/$coworld/$league/play': typeof SiteUnlistedCoworldLeaguePlayRoute
  '/unlisted/$coworld/$league/preview': typeof SiteUnlistedCoworldLeaguePreviewRoute
  '/unlisted/$coworld/$league/start': typeof SiteUnlistedCoworldLeagueStartRoute
  '/unlisted/$coworld/$league/submit': typeof SiteUnlistedCoworldLeagueSubmitRoute
  '/unlisted/$coworld/forum/$postId': typeof SiteUnlistedCoworldForumPostIdRoute
  '/unlisted/$coworld/play/activity': typeof SiteUnlistedCoworldPlayActivityRoute
  '/unlisted/$coworld/play/episodes': typeof SiteUnlistedCoworldPlayEpisodesRoute
  '/unlisted/$coworld/play/requests': typeof SiteUnlistedCoworldPlayRequestsRoute
  '/unlisted/$coworld/preview/edit': typeof SiteUnlistedCoworldPreviewEditRoute
  '/unlisted/$coworld/wiki/$': typeof SiteUnlistedCoworldWikiSplatRoute
  '/unlisted/$coworld/episodes/$episodeId': typeof SiteUnlistedCoworldEpisodesEpisodeIdRoute
  '/unlisted/$coworld/lobbies/$lobbyId': typeof SiteUnlistedCoworldLobbiesLobbyIdRoute
  '/unlisted/$coworld/play-sessions/$sessionId': typeof SiteUnlistedCoworldPlaySessionsSessionIdRoute
  '/unlisted/$coworld/reports/$reportSlug': typeof SiteUnlistedCoworldReportsReportSlugRoute
  '/unlisted/$coworld/$league': typeof SiteUnlistedCoworldLeagueIndexRoute
  '/unlisted/$coworld/forum': typeof SiteUnlistedCoworldForumIndexRoute
  '/unlisted/$coworld/wiki': typeof SiteUnlistedCoworldWikiIndexRoute
  '/unlisted/$coworld/$league/play/activity': typeof SiteUnlistedCoworldLeaguePlayActivityRoute
  '/unlisted/$coworld/$league/play/episodes': typeof SiteUnlistedCoworldLeaguePlayEpisodesRoute
  '/unlisted/$coworld/$league/play/requests': typeof SiteUnlistedCoworldLeaguePlayRequestsRoute
  '/unlisted/$coworld/episode-requests/$requestId/watch': typeof SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute
  '/unlisted/$coworld/episodes/$episodeId/replay': typeof SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_office': typeof OfficeRouteWithChildren
  '/_site': typeof SiteRouteWithChildren
  '/_workspace': typeof WorkspaceRouteWithChildren
  '/_site/$coworld': typeof SiteCoworldRouteWithChildren
  '/_site/account': typeof SiteAccountRouteWithChildren
  '/_site/browse': typeof SiteBrowseRoute
  '/_site/complete-profile': typeof SiteCompleteProfileRoute
  '/_site/coworlds': typeof SiteCoworldsRouteWithChildren
  '/_site/get-started': typeof SiteGetStartedRoute
  '/_site/policies': typeof SitePoliciesRouteWithChildren
  '/_site/search': typeof SiteSearchRoute
  '/_site/sign-in': typeof SiteSignInRoute
  '/_site/watch': typeof SiteWatchRoute
  '/_workspace/ide-next': typeof WorkspaceIdeNextRouteWithChildren
  '/_site/$coworld/$league': typeof SiteCoworldLeagueRouteWithChildren
  '/_site/$coworld/desk': typeof SiteCoworldDeskRoute
  '/_site/$coworld/play': typeof SiteCoworldPlayRoute
  '/_site/$coworld/preview': typeof SiteCoworldPreviewRoute
  '/_site/$coworld/search': typeof SiteCoworldSearchRoute
  '/_site/$coworld/start': typeof SiteCoworldStartRoute
  '/_site/$coworld/submit': typeof SiteCoworldSubmitRoute
  '/_site/account/advanced': typeof SiteAccountAdvancedRoute
  '/_site/account/credentials': typeof SiteAccountCredentialsRoute
  '/_site/cli-auth/complete': typeof SiteCliAuthCompleteRoute
  '/_site/episodes/$episodeId': typeof SiteEpisodesEpisodeIdRoute
  '/_site/experience-requests/$requestId': typeof SiteExperienceRequestsRequestIdRoute
  '/_site/forum/$postId': typeof SiteForumPostIdRoute
  '/_site/github/connect': typeof SiteGithubConnectRoute
  '/_site/lobbies/$lobbyId': typeof SiteLobbiesLobbyIdRoute
  '/_site/play-sessions/$sessionId': typeof SitePlaySessionsSessionIdRoute
  '/_site/play_/$': typeof SitePlaySplatRoute
  '/_site/players/$playerId': typeof SitePlayersPlayerIdRoute
  '/_site/policies/$policyId': typeof SitePoliciesPolicyIdRoute
  '/_site/preview/$': typeof SitePreviewSplatRoute
  '/_site/replays/$coworldId': typeof SiteReplaysCoworldIdRoute
  '/_site/tournaments/$tournamentId': typeof SiteTournamentsTournamentIdRoute
  '/_site/unlisted/$coworld': typeof SiteUnlistedCoworldRouteWithChildren
  '/_site/wiki/$': typeof SiteWikiSplatRoute
  '/_site/$coworld/': typeof SiteCoworldIndexRoute
  '/_site/account/': typeof SiteAccountIndexRoute
  '/_site/cli-auth/': typeof SiteCliAuthIndexRoute
  '/_site/coworlds/': typeof SiteCoworldsIndexRoute
  '/_site/forum/': typeof SiteForumIndexRoute
  '/_site/play/': typeof SitePlayIndexRoute
  '/_site/policies/': typeof SitePoliciesIndexRoute
  '/_site/wiki/': typeof SiteWikiIndexRoute
  '/_workspace/ide-next/': typeof WorkspaceIdeNextIndexRoute
  '/_office/unlisted/office/beltholder': typeof OfficeUnlistedOfficeBeltholderRoute
  '/_office/unlisted/office/campaign-board': typeof OfficeUnlistedOfficeCampaignBoardRoute
  '/_office/unlisted/office/coworld-growth': typeof OfficeUnlistedOfficeCoworldGrowthRoute
  '/_site/$coworld/$league/play': typeof SiteCoworldLeaguePlayRoute
  '/_site/$coworld/$league/preview': typeof SiteCoworldLeaguePreviewRoute
  '/_site/$coworld/$league/start': typeof SiteCoworldLeagueStartRoute
  '/_site/$coworld/$league/submit': typeof SiteCoworldLeagueSubmitRoute
  '/_site/$coworld/forum/$postId': typeof SiteCoworldForumPostIdRoute
  '/_site/$coworld/play_/activity': typeof SiteCoworldPlayActivityRoute
  '/_site/$coworld/play_/episodes': typeof SiteCoworldPlayEpisodesRoute
  '/_site/$coworld/play_/requests': typeof SiteCoworldPlayRequestsRoute
  '/_site/$coworld/preview_/edit': typeof SiteCoworldPreviewEditRoute
  '/_site/$coworld/wiki/$': typeof SiteCoworldWikiSplatRoute
  '/_site/$coworld_/episodes/$episodeId': typeof SiteCoworldEpisodesEpisodeIdRoute
  '/_site/$coworld_/lobbies/$lobbyId': typeof SiteCoworldLobbiesLobbyIdRoute
  '/_site/$coworld_/play-sessions/$sessionId': typeof SiteCoworldPlaySessionsSessionIdRoute
  '/_site/$coworld_/reports/$reportSlug': typeof SiteCoworldReportsReportSlugRoute
  '/_site/coworlds/$name/manage': typeof SiteCoworldsNameManageRoute
  '/_site/coworlds/$name/runs': typeof SiteCoworldsNameRunsRouteWithChildren
  '/_site/episode-requests/$requestId/watch': typeof SiteEpisodeRequestsRequestIdWatchRoute
  '/_site/leagues/$leagueId/settings': typeof SiteLeaguesLeagueIdSettingsRoute
  '/_site/policies/versions/$policyVersionId': typeof SitePoliciesVersionsPolicyVersionIdRoute
  '/_site/unlisted/$coworld/$league': typeof SiteUnlistedCoworldLeagueRouteWithChildren
  '/_site/unlisted/$coworld/desk': typeof SiteUnlistedCoworldDeskRoute
  '/_site/unlisted/$coworld/play': typeof SiteUnlistedCoworldPlayRoute
  '/_site/unlisted/$coworld/preview': typeof SiteUnlistedCoworldPreviewRoute
  '/_site/unlisted/$coworld/search': typeof SiteUnlistedCoworldSearchRoute
  '/_site/unlisted/$coworld/start': typeof SiteUnlistedCoworldStartRoute
  '/_site/unlisted/$coworld/submit': typeof SiteUnlistedCoworldSubmitRoute
  '/_workspace/ide-next/s/$sessionId': typeof WorkspaceIdeNextSSessionIdRoute
  '/_site/$coworld/$league/': typeof SiteCoworldLeagueIndexRoute
  '/_site/$coworld/forum/': typeof SiteCoworldForumIndexRoute
  '/_site/$coworld/wiki/': typeof SiteCoworldWikiIndexRoute
  '/_site/coworlds/$name/': typeof SiteCoworldsNameIndexRoute
  '/_site/unlisted/$coworld/': typeof SiteUnlistedCoworldIndexRoute
  '/_site/$coworld/$league/play_/activity': typeof SiteCoworldLeaguePlayActivityRoute
  '/_site/$coworld/$league/play_/episodes': typeof SiteCoworldLeaguePlayEpisodesRoute
  '/_site/$coworld/$league/play_/requests': typeof SiteCoworldLeaguePlayRequestsRoute
  '/_site/$coworld_/episode-requests/$requestId/watch': typeof SiteCoworldEpisodeRequestsRequestIdWatchRoute
  '/_site/$coworld_/episodes/$episodeId_/replay': typeof SiteCoworldEpisodesEpisodeIdReplayRoute
  '/_site/coworlds/$name/runs/$requestId': typeof SiteCoworldsNameRunsRequestIdRoute
  '/_site/coworlds/$name/runs/new': typeof SiteCoworldsNameRunsNewRoute
  '/_site/unlisted/$coworld/$league/play': typeof SiteUnlistedCoworldLeaguePlayRoute
  '/_site/unlisted/$coworld/$league/preview': typeof SiteUnlistedCoworldLeaguePreviewRoute
  '/_site/unlisted/$coworld/$league/start': typeof SiteUnlistedCoworldLeagueStartRoute
  '/_site/unlisted/$coworld/$league/submit': typeof SiteUnlistedCoworldLeagueSubmitRoute
  '/_site/unlisted/$coworld/forum/$postId': typeof SiteUnlistedCoworldForumPostIdRoute
  '/_site/unlisted/$coworld/play_/activity': typeof SiteUnlistedCoworldPlayActivityRoute
  '/_site/unlisted/$coworld/play_/episodes': typeof SiteUnlistedCoworldPlayEpisodesRoute
  '/_site/unlisted/$coworld/play_/requests': typeof SiteUnlistedCoworldPlayRequestsRoute
  '/_site/unlisted/$coworld/preview_/edit': typeof SiteUnlistedCoworldPreviewEditRoute
  '/_site/unlisted/$coworld/wiki/$': typeof SiteUnlistedCoworldWikiSplatRoute
  '/_site/unlisted/$coworld_/episodes/$episodeId': typeof SiteUnlistedCoworldEpisodesEpisodeIdRoute
  '/_site/unlisted/$coworld_/lobbies/$lobbyId': typeof SiteUnlistedCoworldLobbiesLobbyIdRoute
  '/_site/unlisted/$coworld_/play-sessions/$sessionId': typeof SiteUnlistedCoworldPlaySessionsSessionIdRoute
  '/_site/unlisted/$coworld_/reports/$reportSlug': typeof SiteUnlistedCoworldReportsReportSlugRoute
  '/_site/unlisted/$coworld/$league/': typeof SiteUnlistedCoworldLeagueIndexRoute
  '/_site/unlisted/$coworld/forum/': typeof SiteUnlistedCoworldForumIndexRoute
  '/_site/unlisted/$coworld/wiki/': typeof SiteUnlistedCoworldWikiIndexRoute
  '/_site/unlisted/$coworld/$league/play_/activity': typeof SiteUnlistedCoworldLeaguePlayActivityRoute
  '/_site/unlisted/$coworld/$league/play_/episodes': typeof SiteUnlistedCoworldLeaguePlayEpisodesRoute
  '/_site/unlisted/$coworld/$league/play_/requests': typeof SiteUnlistedCoworldLeaguePlayRequestsRoute
  '/_site/unlisted/$coworld_/episode-requests/$requestId/watch': typeof SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute
  '/_site/unlisted/$coworld_/episodes/$episodeId_/replay': typeof SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$coworld'
    | '/account'
    | '/browse'
    | '/complete-profile'
    | '/coworlds'
    | '/get-started'
    | '/policies'
    | '/search'
    | '/sign-in'
    | '/watch'
    | '/ide-next'
    | '/$coworld/$league'
    | '/$coworld/desk'
    | '/$coworld/play'
    | '/$coworld/preview'
    | '/$coworld/search'
    | '/$coworld/start'
    | '/$coworld/submit'
    | '/account/advanced'
    | '/account/credentials'
    | '/cli-auth/complete'
    | '/episodes/$episodeId'
    | '/experience-requests/$requestId'
    | '/forum/$postId'
    | '/github/connect'
    | '/lobbies/$lobbyId'
    | '/play-sessions/$sessionId'
    | '/play/$'
    | '/players/$playerId'
    | '/policies/$policyId'
    | '/preview/$'
    | '/replays/$coworldId'
    | '/tournaments/$tournamentId'
    | '/unlisted/$coworld'
    | '/wiki/$'
    | '/$coworld/'
    | '/account/'
    | '/cli-auth/'
    | '/coworlds/'
    | '/forum/'
    | '/play/'
    | '/policies/'
    | '/wiki/'
    | '/ide-next/'
    | '/unlisted/office/beltholder'
    | '/unlisted/office/campaign-board'
    | '/unlisted/office/coworld-growth'
    | '/$coworld/$league/play'
    | '/$coworld/$league/preview'
    | '/$coworld/$league/start'
    | '/$coworld/$league/submit'
    | '/$coworld/forum/$postId'
    | '/$coworld/play/activity'
    | '/$coworld/play/episodes'
    | '/$coworld/play/requests'
    | '/$coworld/preview/edit'
    | '/$coworld/wiki/$'
    | '/$coworld/episodes/$episodeId'
    | '/$coworld/lobbies/$lobbyId'
    | '/$coworld/play-sessions/$sessionId'
    | '/$coworld/reports/$reportSlug'
    | '/coworlds/$name/manage'
    | '/coworlds/$name/runs'
    | '/episode-requests/$requestId/watch'
    | '/leagues/$leagueId/settings'
    | '/policies/versions/$policyVersionId'
    | '/unlisted/$coworld/$league'
    | '/unlisted/$coworld/desk'
    | '/unlisted/$coworld/play'
    | '/unlisted/$coworld/preview'
    | '/unlisted/$coworld/search'
    | '/unlisted/$coworld/start'
    | '/unlisted/$coworld/submit'
    | '/ide-next/s/$sessionId'
    | '/$coworld/$league/'
    | '/$coworld/forum/'
    | '/$coworld/wiki/'
    | '/coworlds/$name/'
    | '/unlisted/$coworld/'
    | '/$coworld/$league/play/activity'
    | '/$coworld/$league/play/episodes'
    | '/$coworld/$league/play/requests'
    | '/$coworld/episode-requests/$requestId/watch'
    | '/$coworld/episodes/$episodeId/replay'
    | '/coworlds/$name/runs/$requestId'
    | '/coworlds/$name/runs/new'
    | '/unlisted/$coworld/$league/play'
    | '/unlisted/$coworld/$league/preview'
    | '/unlisted/$coworld/$league/start'
    | '/unlisted/$coworld/$league/submit'
    | '/unlisted/$coworld/forum/$postId'
    | '/unlisted/$coworld/play/activity'
    | '/unlisted/$coworld/play/episodes'
    | '/unlisted/$coworld/play/requests'
    | '/unlisted/$coworld/preview/edit'
    | '/unlisted/$coworld/wiki/$'
    | '/unlisted/$coworld/episodes/$episodeId'
    | '/unlisted/$coworld/lobbies/$lobbyId'
    | '/unlisted/$coworld/play-sessions/$sessionId'
    | '/unlisted/$coworld/reports/$reportSlug'
    | '/unlisted/$coworld/$league/'
    | '/unlisted/$coworld/forum/'
    | '/unlisted/$coworld/wiki/'
    | '/unlisted/$coworld/$league/play/activity'
    | '/unlisted/$coworld/$league/play/episodes'
    | '/unlisted/$coworld/$league/play/requests'
    | '/unlisted/$coworld/episode-requests/$requestId/watch'
    | '/unlisted/$coworld/episodes/$episodeId/replay'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/browse'
    | '/complete-profile'
    | '/get-started'
    | '/search'
    | '/sign-in'
    | '/watch'
    | '/$coworld/desk'
    | '/$coworld/play'
    | '/$coworld/preview'
    | '/$coworld/search'
    | '/$coworld/start'
    | '/$coworld/submit'
    | '/account/advanced'
    | '/account/credentials'
    | '/cli-auth/complete'
    | '/episodes/$episodeId'
    | '/experience-requests/$requestId'
    | '/forum/$postId'
    | '/github/connect'
    | '/lobbies/$lobbyId'
    | '/play-sessions/$sessionId'
    | '/play/$'
    | '/players/$playerId'
    | '/policies/$policyId'
    | '/preview/$'
    | '/replays/$coworldId'
    | '/tournaments/$tournamentId'
    | '/wiki/$'
    | '/$coworld'
    | '/account'
    | '/cli-auth'
    | '/coworlds'
    | '/forum'
    | '/play'
    | '/policies'
    | '/wiki'
    | '/ide-next'
    | '/unlisted/office/beltholder'
    | '/unlisted/office/campaign-board'
    | '/unlisted/office/coworld-growth'
    | '/$coworld/$league/play'
    | '/$coworld/$league/preview'
    | '/$coworld/$league/start'
    | '/$coworld/$league/submit'
    | '/$coworld/forum/$postId'
    | '/$coworld/play/activity'
    | '/$coworld/play/episodes'
    | '/$coworld/play/requests'
    | '/$coworld/preview/edit'
    | '/$coworld/wiki/$'
    | '/$coworld/episodes/$episodeId'
    | '/$coworld/lobbies/$lobbyId'
    | '/$coworld/play-sessions/$sessionId'
    | '/$coworld/reports/$reportSlug'
    | '/coworlds/$name/manage'
    | '/coworlds/$name/runs'
    | '/episode-requests/$requestId/watch'
    | '/leagues/$leagueId/settings'
    | '/policies/versions/$policyVersionId'
    | '/unlisted/$coworld/desk'
    | '/unlisted/$coworld/play'
    | '/unlisted/$coworld/preview'
    | '/unlisted/$coworld/search'
    | '/unlisted/$coworld/start'
    | '/unlisted/$coworld/submit'
    | '/ide-next/s/$sessionId'
    | '/$coworld/$league'
    | '/$coworld/forum'
    | '/$coworld/wiki'
    | '/coworlds/$name'
    | '/unlisted/$coworld'
    | '/$coworld/$league/play/activity'
    | '/$coworld/$league/play/episodes'
    | '/$coworld/$league/play/requests'
    | '/$coworld/episode-requests/$requestId/watch'
    | '/$coworld/episodes/$episodeId/replay'
    | '/coworlds/$name/runs/$requestId'
    | '/coworlds/$name/runs/new'
    | '/unlisted/$coworld/$league/play'
    | '/unlisted/$coworld/$league/preview'
    | '/unlisted/$coworld/$league/start'
    | '/unlisted/$coworld/$league/submit'
    | '/unlisted/$coworld/forum/$postId'
    | '/unlisted/$coworld/play/activity'
    | '/unlisted/$coworld/play/episodes'
    | '/unlisted/$coworld/play/requests'
    | '/unlisted/$coworld/preview/edit'
    | '/unlisted/$coworld/wiki/$'
    | '/unlisted/$coworld/episodes/$episodeId'
    | '/unlisted/$coworld/lobbies/$lobbyId'
    | '/unlisted/$coworld/play-sessions/$sessionId'
    | '/unlisted/$coworld/reports/$reportSlug'
    | '/unlisted/$coworld/$league'
    | '/unlisted/$coworld/forum'
    | '/unlisted/$coworld/wiki'
    | '/unlisted/$coworld/$league/play/activity'
    | '/unlisted/$coworld/$league/play/episodes'
    | '/unlisted/$coworld/$league/play/requests'
    | '/unlisted/$coworld/episode-requests/$requestId/watch'
    | '/unlisted/$coworld/episodes/$episodeId/replay'
  id:
    | '__root__'
    | '/_office'
    | '/_site'
    | '/_workspace'
    | '/_site/$coworld'
    | '/_site/account'
    | '/_site/browse'
    | '/_site/complete-profile'
    | '/_site/coworlds'
    | '/_site/get-started'
    | '/_site/policies'
    | '/_site/search'
    | '/_site/sign-in'
    | '/_site/watch'
    | '/_workspace/ide-next'
    | '/_site/$coworld/$league'
    | '/_site/$coworld/desk'
    | '/_site/$coworld/play'
    | '/_site/$coworld/preview'
    | '/_site/$coworld/search'
    | '/_site/$coworld/start'
    | '/_site/$coworld/submit'
    | '/_site/account/advanced'
    | '/_site/account/credentials'
    | '/_site/cli-auth/complete'
    | '/_site/episodes/$episodeId'
    | '/_site/experience-requests/$requestId'
    | '/_site/forum/$postId'
    | '/_site/github/connect'
    | '/_site/lobbies/$lobbyId'
    | '/_site/play-sessions/$sessionId'
    | '/_site/play_/$'
    | '/_site/players/$playerId'
    | '/_site/policies/$policyId'
    | '/_site/preview/$'
    | '/_site/replays/$coworldId'
    | '/_site/tournaments/$tournamentId'
    | '/_site/unlisted/$coworld'
    | '/_site/wiki/$'
    | '/_site/$coworld/'
    | '/_site/account/'
    | '/_site/cli-auth/'
    | '/_site/coworlds/'
    | '/_site/forum/'
    | '/_site/play/'
    | '/_site/policies/'
    | '/_site/wiki/'
    | '/_workspace/ide-next/'
    | '/_office/unlisted/office/beltholder'
    | '/_office/unlisted/office/campaign-board'
    | '/_office/unlisted/office/coworld-growth'
    | '/_site/$coworld/$league/play'
    | '/_site/$coworld/$league/preview'
    | '/_site/$coworld/$league/start'
    | '/_site/$coworld/$league/submit'
    | '/_site/$coworld/forum/$postId'
    | '/_site/$coworld/play_/activity'
    | '/_site/$coworld/play_/episodes'
    | '/_site/$coworld/play_/requests'
    | '/_site/$coworld/preview_/edit'
    | '/_site/$coworld/wiki/$'
    | '/_site/$coworld_/episodes/$episodeId'
    | '/_site/$coworld_/lobbies/$lobbyId'
    | '/_site/$coworld_/play-sessions/$sessionId'
    | '/_site/$coworld_/reports/$reportSlug'
    | '/_site/coworlds/$name/manage'
    | '/_site/coworlds/$name/runs'
    | '/_site/episode-requests/$requestId/watch'
    | '/_site/leagues/$leagueId/settings'
    | '/_site/policies/versions/$policyVersionId'
    | '/_site/unlisted/$coworld/$league'
    | '/_site/unlisted/$coworld/desk'
    | '/_site/unlisted/$coworld/play'
    | '/_site/unlisted/$coworld/preview'
    | '/_site/unlisted/$coworld/search'
    | '/_site/unlisted/$coworld/start'
    | '/_site/unlisted/$coworld/submit'
    | '/_workspace/ide-next/s/$sessionId'
    | '/_site/$coworld/$league/'
    | '/_site/$coworld/forum/'
    | '/_site/$coworld/wiki/'
    | '/_site/coworlds/$name/'
    | '/_site/unlisted/$coworld/'
    | '/_site/$coworld/$league/play_/activity'
    | '/_site/$coworld/$league/play_/episodes'
    | '/_site/$coworld/$league/play_/requests'
    | '/_site/$coworld_/episode-requests/$requestId/watch'
    | '/_site/$coworld_/episodes/$episodeId_/replay'
    | '/_site/coworlds/$name/runs/$requestId'
    | '/_site/coworlds/$name/runs/new'
    | '/_site/unlisted/$coworld/$league/play'
    | '/_site/unlisted/$coworld/$league/preview'
    | '/_site/unlisted/$coworld/$league/start'
    | '/_site/unlisted/$coworld/$league/submit'
    | '/_site/unlisted/$coworld/forum/$postId'
    | '/_site/unlisted/$coworld/play_/activity'
    | '/_site/unlisted/$coworld/play_/episodes'
    | '/_site/unlisted/$coworld/play_/requests'
    | '/_site/unlisted/$coworld/preview_/edit'
    | '/_site/unlisted/$coworld/wiki/$'
    | '/_site/unlisted/$coworld_/episodes/$episodeId'
    | '/_site/unlisted/$coworld_/lobbies/$lobbyId'
    | '/_site/unlisted/$coworld_/play-sessions/$sessionId'
    | '/_site/unlisted/$coworld_/reports/$reportSlug'
    | '/_site/unlisted/$coworld/$league/'
    | '/_site/unlisted/$coworld/forum/'
    | '/_site/unlisted/$coworld/wiki/'
    | '/_site/unlisted/$coworld/$league/play_/activity'
    | '/_site/unlisted/$coworld/$league/play_/episodes'
    | '/_site/unlisted/$coworld/$league/play_/requests'
    | '/_site/unlisted/$coworld_/episode-requests/$requestId/watch'
    | '/_site/unlisted/$coworld_/episodes/$episodeId_/replay'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  OfficeRoute: typeof OfficeRouteWithChildren
  SiteRoute: typeof SiteRouteWithChildren
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_office': {
      id: '/_office'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OfficeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_site': {
      id: '/_site'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace': {
      id: '/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_site/$coworld': {
      id: '/_site/$coworld'
      path: '/$coworld'
      fullPath: '/$coworld'
      preLoaderRoute: typeof SiteCoworldRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/account': {
      id: '/_site/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof SiteAccountRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/browse': {
      id: '/_site/browse'
      path: '/browse'
      fullPath: '/browse'
      preLoaderRoute: typeof SiteBrowseRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/complete-profile': {
      id: '/_site/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof SiteCompleteProfileRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/coworlds': {
      id: '/_site/coworlds'
      path: '/coworlds'
      fullPath: '/coworlds'
      preLoaderRoute: typeof SiteCoworldsRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/get-started': {
      id: '/_site/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof SiteGetStartedRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/policies': {
      id: '/_site/policies'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof SitePoliciesRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/search': {
      id: '/_site/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SiteSearchRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/sign-in': {
      id: '/_site/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SiteSignInRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/watch': {
      id: '/_site/watch'
      path: '/watch'
      fullPath: '/watch'
      preLoaderRoute: typeof SiteWatchRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_workspace/ide-next': {
      id: '/_workspace/ide-next'
      path: '/ide-next'
      fullPath: '/ide-next'
      preLoaderRoute: typeof WorkspaceIdeNextRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_site/$coworld/': {
      id: '/_site/$coworld/'
      path: '/'
      fullPath: '/$coworld/'
      preLoaderRoute: typeof SiteCoworldIndexRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/$league': {
      id: '/_site/$coworld/$league'
      path: '/$league'
      fullPath: '/$coworld/$league'
      preLoaderRoute: typeof SiteCoworldLeagueRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/desk': {
      id: '/_site/$coworld/desk'
      path: '/desk'
      fullPath: '/$coworld/desk'
      preLoaderRoute: typeof SiteCoworldDeskRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/play': {
      id: '/_site/$coworld/play'
      path: '/play'
      fullPath: '/$coworld/play'
      preLoaderRoute: typeof SiteCoworldPlayRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/preview': {
      id: '/_site/$coworld/preview'
      path: '/preview'
      fullPath: '/$coworld/preview'
      preLoaderRoute: typeof SiteCoworldPreviewRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/search': {
      id: '/_site/$coworld/search'
      path: '/search'
      fullPath: '/$coworld/search'
      preLoaderRoute: typeof SiteCoworldSearchRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/start': {
      id: '/_site/$coworld/start'
      path: '/start'
      fullPath: '/$coworld/start'
      preLoaderRoute: typeof SiteCoworldStartRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/submit': {
      id: '/_site/$coworld/submit'
      path: '/submit'
      fullPath: '/$coworld/submit'
      preLoaderRoute: typeof SiteCoworldSubmitRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/account/': {
      id: '/_site/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof SiteAccountIndexRouteImport
      parentRoute: typeof SiteAccountRoute
    }
    '/_site/account/advanced': {
      id: '/_site/account/advanced'
      path: '/advanced'
      fullPath: '/account/advanced'
      preLoaderRoute: typeof SiteAccountAdvancedRouteImport
      parentRoute: typeof SiteAccountRoute
    }
    '/_site/account/credentials': {
      id: '/_site/account/credentials'
      path: '/credentials'
      fullPath: '/account/credentials'
      preLoaderRoute: typeof SiteAccountCredentialsRouteImport
      parentRoute: typeof SiteAccountRoute
    }
    '/_site/cli-auth/': {
      id: '/_site/cli-auth/'
      path: '/cli-auth'
      fullPath: '/cli-auth/'
      preLoaderRoute: typeof SiteCliAuthIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/cli-auth/complete': {
      id: '/_site/cli-auth/complete'
      path: '/cli-auth/complete'
      fullPath: '/cli-auth/complete'
      preLoaderRoute: typeof SiteCliAuthCompleteRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/coworlds/': {
      id: '/_site/coworlds/'
      path: '/'
      fullPath: '/coworlds/'
      preLoaderRoute: typeof SiteCoworldsIndexRouteImport
      parentRoute: typeof SiteCoworldsRoute
    }
    '/_site/episodes/$episodeId': {
      id: '/_site/episodes/$episodeId'
      path: '/episodes/$episodeId'
      fullPath: '/episodes/$episodeId'
      preLoaderRoute: typeof SiteEpisodesEpisodeIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/experience-requests/$requestId': {
      id: '/_site/experience-requests/$requestId'
      path: '/experience-requests/$requestId'
      fullPath: '/experience-requests/$requestId'
      preLoaderRoute: typeof SiteExperienceRequestsRequestIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/forum/': {
      id: '/_site/forum/'
      path: '/forum'
      fullPath: '/forum/'
      preLoaderRoute: typeof SiteForumIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/forum/$postId': {
      id: '/_site/forum/$postId'
      path: '/forum/$postId'
      fullPath: '/forum/$postId'
      preLoaderRoute: typeof SiteForumPostIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/github/connect': {
      id: '/_site/github/connect'
      path: '/github/connect'
      fullPath: '/github/connect'
      preLoaderRoute: typeof SiteGithubConnectRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/lobbies/$lobbyId': {
      id: '/_site/lobbies/$lobbyId'
      path: '/lobbies/$lobbyId'
      fullPath: '/lobbies/$lobbyId'
      preLoaderRoute: typeof SiteLobbiesLobbyIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/play-sessions/$sessionId': {
      id: '/_site/play-sessions/$sessionId'
      path: '/play-sessions/$sessionId'
      fullPath: '/play-sessions/$sessionId'
      preLoaderRoute: typeof SitePlaySessionsSessionIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/play/': {
      id: '/_site/play/'
      path: '/play'
      fullPath: '/play/'
      preLoaderRoute: typeof SitePlayIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/play_/$': {
      id: '/_site/play_/$'
      path: '/play/$'
      fullPath: '/play/$'
      preLoaderRoute: typeof SitePlaySplatRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/players/$playerId': {
      id: '/_site/players/$playerId'
      path: '/players/$playerId'
      fullPath: '/players/$playerId'
      preLoaderRoute: typeof SitePlayersPlayerIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/policies/': {
      id: '/_site/policies/'
      path: '/'
      fullPath: '/policies/'
      preLoaderRoute: typeof SitePoliciesIndexRouteImport
      parentRoute: typeof SitePoliciesRoute
    }
    '/_site/policies/$policyId': {
      id: '/_site/policies/$policyId'
      path: '/$policyId'
      fullPath: '/policies/$policyId'
      preLoaderRoute: typeof SitePoliciesPolicyIdRouteImport
      parentRoute: typeof SitePoliciesRoute
    }
    '/_site/preview/$': {
      id: '/_site/preview/$'
      path: '/preview/$'
      fullPath: '/preview/$'
      preLoaderRoute: typeof SitePreviewSplatRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/replays/$coworldId': {
      id: '/_site/replays/$coworldId'
      path: '/replays/$coworldId'
      fullPath: '/replays/$coworldId'
      preLoaderRoute: typeof SiteReplaysCoworldIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/tournaments/$tournamentId': {
      id: '/_site/tournaments/$tournamentId'
      path: '/tournaments/$tournamentId'
      fullPath: '/tournaments/$tournamentId'
      preLoaderRoute: typeof SiteTournamentsTournamentIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/unlisted/$coworld': {
      id: '/_site/unlisted/$coworld'
      path: '/unlisted/$coworld'
      fullPath: '/unlisted/$coworld'
      preLoaderRoute: typeof SiteUnlistedCoworldRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/wiki/': {
      id: '/_site/wiki/'
      path: '/wiki'
      fullPath: '/wiki/'
      preLoaderRoute: typeof SiteWikiIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/wiki/$': {
      id: '/_site/wiki/$'
      path: '/wiki/$'
      fullPath: '/wiki/$'
      preLoaderRoute: typeof SiteWikiSplatRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_workspace/ide-next/': {
      id: '/_workspace/ide-next/'
      path: '/'
      fullPath: '/ide-next/'
      preLoaderRoute: typeof WorkspaceIdeNextIndexRouteImport
      parentRoute: typeof WorkspaceIdeNextRoute
    }
    '/_office/unlisted/office/beltholder': {
      id: '/_office/unlisted/office/beltholder'
      path: '/unlisted/office/beltholder'
      fullPath: '/unlisted/office/beltholder'
      preLoaderRoute: typeof OfficeUnlistedOfficeBeltholderRouteImport
      parentRoute: typeof OfficeRoute
    }
    '/_office/unlisted/office/campaign-board': {
      id: '/_office/unlisted/office/campaign-board'
      path: '/unlisted/office/campaign-board'
      fullPath: '/unlisted/office/campaign-board'
      preLoaderRoute: typeof OfficeUnlistedOfficeCampaignBoardRouteImport
      parentRoute: typeof OfficeRoute
    }
    '/_office/unlisted/office/coworld-growth': {
      id: '/_office/unlisted/office/coworld-growth'
      path: '/unlisted/office/coworld-growth'
      fullPath: '/unlisted/office/coworld-growth'
      preLoaderRoute: typeof OfficeUnlistedOfficeCoworldGrowthRouteImport
      parentRoute: typeof OfficeRoute
    }
    '/_site/$coworld/$league/': {
      id: '/_site/$coworld/$league/'
      path: '/'
      fullPath: '/$coworld/$league/'
      preLoaderRoute: typeof SiteCoworldLeagueIndexRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/$league/play': {
      id: '/_site/$coworld/$league/play'
      path: '/play'
      fullPath: '/$coworld/$league/play'
      preLoaderRoute: typeof SiteCoworldLeaguePlayRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/$league/preview': {
      id: '/_site/$coworld/$league/preview'
      path: '/preview'
      fullPath: '/$coworld/$league/preview'
      preLoaderRoute: typeof SiteCoworldLeaguePreviewRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/$league/start': {
      id: '/_site/$coworld/$league/start'
      path: '/start'
      fullPath: '/$coworld/$league/start'
      preLoaderRoute: typeof SiteCoworldLeagueStartRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/$league/submit': {
      id: '/_site/$coworld/$league/submit'
      path: '/submit'
      fullPath: '/$coworld/$league/submit'
      preLoaderRoute: typeof SiteCoworldLeagueSubmitRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/forum/': {
      id: '/_site/$coworld/forum/'
      path: '/forum'
      fullPath: '/$coworld/forum/'
      preLoaderRoute: typeof SiteCoworldForumIndexRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/forum/$postId': {
      id: '/_site/$coworld/forum/$postId'
      path: '/forum/$postId'
      fullPath: '/$coworld/forum/$postId'
      preLoaderRoute: typeof SiteCoworldForumPostIdRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/play_/activity': {
      id: '/_site/$coworld/play_/activity'
      path: '/play/activity'
      fullPath: '/$coworld/play/activity'
      preLoaderRoute: typeof SiteCoworldPlayActivityRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/play_/episodes': {
      id: '/_site/$coworld/play_/episodes'
      path: '/play/episodes'
      fullPath: '/$coworld/play/episodes'
      preLoaderRoute: typeof SiteCoworldPlayEpisodesRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/play_/requests': {
      id: '/_site/$coworld/play_/requests'
      path: '/play/requests'
      fullPath: '/$coworld/play/requests'
      preLoaderRoute: typeof SiteCoworldPlayRequestsRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/preview_/edit': {
      id: '/_site/$coworld/preview_/edit'
      path: '/preview/edit'
      fullPath: '/$coworld/preview/edit'
      preLoaderRoute: typeof SiteCoworldPreviewEditRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/wiki/': {
      id: '/_site/$coworld/wiki/'
      path: '/wiki'
      fullPath: '/$coworld/wiki/'
      preLoaderRoute: typeof SiteCoworldWikiIndexRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld/wiki/$': {
      id: '/_site/$coworld/wiki/$'
      path: '/wiki/$'
      fullPath: '/$coworld/wiki/$'
      preLoaderRoute: typeof SiteCoworldWikiSplatRouteImport
      parentRoute: typeof SiteCoworldRoute
    }
    '/_site/$coworld_/episodes/$episodeId': {
      id: '/_site/$coworld_/episodes/$episodeId'
      path: '/$coworld/episodes/$episodeId'
      fullPath: '/$coworld/episodes/$episodeId'
      preLoaderRoute: typeof SiteCoworldEpisodesEpisodeIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/$coworld_/lobbies/$lobbyId': {
      id: '/_site/$coworld_/lobbies/$lobbyId'
      path: '/$coworld/lobbies/$lobbyId'
      fullPath: '/$coworld/lobbies/$lobbyId'
      preLoaderRoute: typeof SiteCoworldLobbiesLobbyIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/$coworld_/play-sessions/$sessionId': {
      id: '/_site/$coworld_/play-sessions/$sessionId'
      path: '/$coworld/play-sessions/$sessionId'
      fullPath: '/$coworld/play-sessions/$sessionId'
      preLoaderRoute: typeof SiteCoworldPlaySessionsSessionIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/$coworld_/reports/$reportSlug': {
      id: '/_site/$coworld_/reports/$reportSlug'
      path: '/$coworld/reports/$reportSlug'
      fullPath: '/$coworld/reports/$reportSlug'
      preLoaderRoute: typeof SiteCoworldReportsReportSlugRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/coworlds/$name/': {
      id: '/_site/coworlds/$name/'
      path: '/$name'
      fullPath: '/coworlds/$name/'
      preLoaderRoute: typeof SiteCoworldsNameIndexRouteImport
      parentRoute: typeof SiteCoworldsRoute
    }
    '/_site/coworlds/$name/manage': {
      id: '/_site/coworlds/$name/manage'
      path: '/$name/manage'
      fullPath: '/coworlds/$name/manage'
      preLoaderRoute: typeof SiteCoworldsNameManageRouteImport
      parentRoute: typeof SiteCoworldsRoute
    }
    '/_site/coworlds/$name/runs': {
      id: '/_site/coworlds/$name/runs'
      path: '/$name/runs'
      fullPath: '/coworlds/$name/runs'
      preLoaderRoute: typeof SiteCoworldsNameRunsRouteImport
      parentRoute: typeof SiteCoworldsRoute
    }
    '/_site/episode-requests/$requestId/watch': {
      id: '/_site/episode-requests/$requestId/watch'
      path: '/episode-requests/$requestId/watch'
      fullPath: '/episode-requests/$requestId/watch'
      preLoaderRoute: typeof SiteEpisodeRequestsRequestIdWatchRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/leagues/$leagueId/settings': {
      id: '/_site/leagues/$leagueId/settings'
      path: '/leagues/$leagueId/settings'
      fullPath: '/leagues/$leagueId/settings'
      preLoaderRoute: typeof SiteLeaguesLeagueIdSettingsRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/policies/versions/$policyVersionId': {
      id: '/_site/policies/versions/$policyVersionId'
      path: '/versions/$policyVersionId'
      fullPath: '/policies/versions/$policyVersionId'
      preLoaderRoute: typeof SitePoliciesVersionsPolicyVersionIdRouteImport
      parentRoute: typeof SitePoliciesRoute
    }
    '/_site/unlisted/$coworld/': {
      id: '/_site/unlisted/$coworld/'
      path: '/'
      fullPath: '/unlisted/$coworld/'
      preLoaderRoute: typeof SiteUnlistedCoworldIndexRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/$league': {
      id: '/_site/unlisted/$coworld/$league'
      path: '/$league'
      fullPath: '/unlisted/$coworld/$league'
      preLoaderRoute: typeof SiteUnlistedCoworldLeagueRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/desk': {
      id: '/_site/unlisted/$coworld/desk'
      path: '/desk'
      fullPath: '/unlisted/$coworld/desk'
      preLoaderRoute: typeof SiteUnlistedCoworldDeskRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/play': {
      id: '/_site/unlisted/$coworld/play'
      path: '/play'
      fullPath: '/unlisted/$coworld/play'
      preLoaderRoute: typeof SiteUnlistedCoworldPlayRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/preview': {
      id: '/_site/unlisted/$coworld/preview'
      path: '/preview'
      fullPath: '/unlisted/$coworld/preview'
      preLoaderRoute: typeof SiteUnlistedCoworldPreviewRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/search': {
      id: '/_site/unlisted/$coworld/search'
      path: '/search'
      fullPath: '/unlisted/$coworld/search'
      preLoaderRoute: typeof SiteUnlistedCoworldSearchRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/start': {
      id: '/_site/unlisted/$coworld/start'
      path: '/start'
      fullPath: '/unlisted/$coworld/start'
      preLoaderRoute: typeof SiteUnlistedCoworldStartRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/submit': {
      id: '/_site/unlisted/$coworld/submit'
      path: '/submit'
      fullPath: '/unlisted/$coworld/submit'
      preLoaderRoute: typeof SiteUnlistedCoworldSubmitRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_workspace/ide-next/s/$sessionId': {
      id: '/_workspace/ide-next/s/$sessionId'
      path: '/s/$sessionId'
      fullPath: '/ide-next/s/$sessionId'
      preLoaderRoute: typeof WorkspaceIdeNextSSessionIdRouteImport
      parentRoute: typeof WorkspaceIdeNextRoute
    }
    '/_site/$coworld/$league/play_/activity': {
      id: '/_site/$coworld/$league/play_/activity'
      path: '/play/activity'
      fullPath: '/$coworld/$league/play/activity'
      preLoaderRoute: typeof SiteCoworldLeaguePlayActivityRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/$league/play_/episodes': {
      id: '/_site/$coworld/$league/play_/episodes'
      path: '/play/episodes'
      fullPath: '/$coworld/$league/play/episodes'
      preLoaderRoute: typeof SiteCoworldLeaguePlayEpisodesRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld/$league/play_/requests': {
      id: '/_site/$coworld/$league/play_/requests'
      path: '/play/requests'
      fullPath: '/$coworld/$league/play/requests'
      preLoaderRoute: typeof SiteCoworldLeaguePlayRequestsRouteImport
      parentRoute: typeof SiteCoworldLeagueRoute
    }
    '/_site/$coworld_/episode-requests/$requestId/watch': {
      id: '/_site/$coworld_/episode-requests/$requestId/watch'
      path: '/$coworld/episode-requests/$requestId/watch'
      fullPath: '/$coworld/episode-requests/$requestId/watch'
      preLoaderRoute: typeof SiteCoworldEpisodeRequestsRequestIdWatchRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/$coworld_/episodes/$episodeId_/replay': {
      id: '/_site/$coworld_/episodes/$episodeId_/replay'
      path: '/$coworld/episodes/$episodeId/replay'
      fullPath: '/$coworld/episodes/$episodeId/replay'
      preLoaderRoute: typeof SiteCoworldEpisodesEpisodeIdReplayRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/coworlds/$name/runs/$requestId': {
      id: '/_site/coworlds/$name/runs/$requestId'
      path: '/$requestId'
      fullPath: '/coworlds/$name/runs/$requestId'
      preLoaderRoute: typeof SiteCoworldsNameRunsRequestIdRouteImport
      parentRoute: typeof SiteCoworldsNameRunsRoute
    }
    '/_site/coworlds/$name/runs/new': {
      id: '/_site/coworlds/$name/runs/new'
      path: '/new'
      fullPath: '/coworlds/$name/runs/new'
      preLoaderRoute: typeof SiteCoworldsNameRunsNewRouteImport
      parentRoute: typeof SiteCoworldsNameRunsRoute
    }
    '/_site/unlisted/$coworld/$league/': {
      id: '/_site/unlisted/$coworld/$league/'
      path: '/'
      fullPath: '/unlisted/$coworld/$league/'
      preLoaderRoute: typeof SiteUnlistedCoworldLeagueIndexRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/$league/play': {
      id: '/_site/unlisted/$coworld/$league/play'
      path: '/play'
      fullPath: '/unlisted/$coworld/$league/play'
      preLoaderRoute: typeof SiteUnlistedCoworldLeaguePlayRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/$league/preview': {
      id: '/_site/unlisted/$coworld/$league/preview'
      path: '/preview'
      fullPath: '/unlisted/$coworld/$league/preview'
      preLoaderRoute: typeof SiteUnlistedCoworldLeaguePreviewRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/$league/start': {
      id: '/_site/unlisted/$coworld/$league/start'
      path: '/start'
      fullPath: '/unlisted/$coworld/$league/start'
      preLoaderRoute: typeof SiteUnlistedCoworldLeagueStartRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/$league/submit': {
      id: '/_site/unlisted/$coworld/$league/submit'
      path: '/submit'
      fullPath: '/unlisted/$coworld/$league/submit'
      preLoaderRoute: typeof SiteUnlistedCoworldLeagueSubmitRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/forum/': {
      id: '/_site/unlisted/$coworld/forum/'
      path: '/forum'
      fullPath: '/unlisted/$coworld/forum/'
      preLoaderRoute: typeof SiteUnlistedCoworldForumIndexRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/forum/$postId': {
      id: '/_site/unlisted/$coworld/forum/$postId'
      path: '/forum/$postId'
      fullPath: '/unlisted/$coworld/forum/$postId'
      preLoaderRoute: typeof SiteUnlistedCoworldForumPostIdRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/play_/activity': {
      id: '/_site/unlisted/$coworld/play_/activity'
      path: '/play/activity'
      fullPath: '/unlisted/$coworld/play/activity'
      preLoaderRoute: typeof SiteUnlistedCoworldPlayActivityRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/play_/episodes': {
      id: '/_site/unlisted/$coworld/play_/episodes'
      path: '/play/episodes'
      fullPath: '/unlisted/$coworld/play/episodes'
      preLoaderRoute: typeof SiteUnlistedCoworldPlayEpisodesRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/play_/requests': {
      id: '/_site/unlisted/$coworld/play_/requests'
      path: '/play/requests'
      fullPath: '/unlisted/$coworld/play/requests'
      preLoaderRoute: typeof SiteUnlistedCoworldPlayRequestsRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/preview_/edit': {
      id: '/_site/unlisted/$coworld/preview_/edit'
      path: '/preview/edit'
      fullPath: '/unlisted/$coworld/preview/edit'
      preLoaderRoute: typeof SiteUnlistedCoworldPreviewEditRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/wiki/': {
      id: '/_site/unlisted/$coworld/wiki/'
      path: '/wiki'
      fullPath: '/unlisted/$coworld/wiki/'
      preLoaderRoute: typeof SiteUnlistedCoworldWikiIndexRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld/wiki/$': {
      id: '/_site/unlisted/$coworld/wiki/$'
      path: '/wiki/$'
      fullPath: '/unlisted/$coworld/wiki/$'
      preLoaderRoute: typeof SiteUnlistedCoworldWikiSplatRouteImport
      parentRoute: typeof SiteUnlistedCoworldRoute
    }
    '/_site/unlisted/$coworld_/episodes/$episodeId': {
      id: '/_site/unlisted/$coworld_/episodes/$episodeId'
      path: '/unlisted/$coworld/episodes/$episodeId'
      fullPath: '/unlisted/$coworld/episodes/$episodeId'
      preLoaderRoute: typeof SiteUnlistedCoworldEpisodesEpisodeIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/unlisted/$coworld_/lobbies/$lobbyId': {
      id: '/_site/unlisted/$coworld_/lobbies/$lobbyId'
      path: '/unlisted/$coworld/lobbies/$lobbyId'
      fullPath: '/unlisted/$coworld/lobbies/$lobbyId'
      preLoaderRoute: typeof SiteUnlistedCoworldLobbiesLobbyIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/unlisted/$coworld_/play-sessions/$sessionId': {
      id: '/_site/unlisted/$coworld_/play-sessions/$sessionId'
      path: '/unlisted/$coworld/play-sessions/$sessionId'
      fullPath: '/unlisted/$coworld/play-sessions/$sessionId'
      preLoaderRoute: typeof SiteUnlistedCoworldPlaySessionsSessionIdRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/unlisted/$coworld_/reports/$reportSlug': {
      id: '/_site/unlisted/$coworld_/reports/$reportSlug'
      path: '/unlisted/$coworld/reports/$reportSlug'
      fullPath: '/unlisted/$coworld/reports/$reportSlug'
      preLoaderRoute: typeof SiteUnlistedCoworldReportsReportSlugRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/unlisted/$coworld/$league/play_/activity': {
      id: '/_site/unlisted/$coworld/$league/play_/activity'
      path: '/play/activity'
      fullPath: '/unlisted/$coworld/$league/play/activity'
      preLoaderRoute: typeof SiteUnlistedCoworldLeaguePlayActivityRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/$league/play_/episodes': {
      id: '/_site/unlisted/$coworld/$league/play_/episodes'
      path: '/play/episodes'
      fullPath: '/unlisted/$coworld/$league/play/episodes'
      preLoaderRoute: typeof SiteUnlistedCoworldLeaguePlayEpisodesRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld/$league/play_/requests': {
      id: '/_site/unlisted/$coworld/$league/play_/requests'
      path: '/play/requests'
      fullPath: '/unlisted/$coworld/$league/play/requests'
      preLoaderRoute: typeof SiteUnlistedCoworldLeaguePlayRequestsRouteImport
      parentRoute: typeof SiteUnlistedCoworldLeagueRoute
    }
    '/_site/unlisted/$coworld_/episode-requests/$requestId/watch': {
      id: '/_site/unlisted/$coworld_/episode-requests/$requestId/watch'
      path: '/unlisted/$coworld/episode-requests/$requestId/watch'
      fullPath: '/unlisted/$coworld/episode-requests/$requestId/watch'
      preLoaderRoute: typeof SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/unlisted/$coworld_/episodes/$episodeId_/replay': {
      id: '/_site/unlisted/$coworld_/episodes/$episodeId_/replay'
      path: '/unlisted/$coworld/episodes/$episodeId/replay'
      fullPath: '/unlisted/$coworld/episodes/$episodeId/replay'
      preLoaderRoute: typeof SiteUnlistedCoworldEpisodesEpisodeIdReplayRouteImport
      parentRoute: typeof SiteRoute
    }
  }
}

interface OfficeRouteChildren {
  OfficeUnlistedOfficeBeltholderRoute: typeof OfficeUnlistedOfficeBeltholderRoute
  OfficeUnlistedOfficeCampaignBoardRoute: typeof OfficeUnlistedOfficeCampaignBoardRoute
  OfficeUnlistedOfficeCoworldGrowthRoute: typeof OfficeUnlistedOfficeCoworldGrowthRoute
}

const OfficeRouteChildren: OfficeRouteChildren = {
  OfficeUnlistedOfficeBeltholderRoute: OfficeUnlistedOfficeBeltholderRoute,
  OfficeUnlistedOfficeCampaignBoardRoute:
    OfficeUnlistedOfficeCampaignBoardRoute,
  OfficeUnlistedOfficeCoworldGrowthRoute:
    OfficeUnlistedOfficeCoworldGrowthRoute,
}

const OfficeRouteWithChildren =
  OfficeRoute._addFileChildren(OfficeRouteChildren)

interface SiteCoworldLeagueRouteChildren {
  SiteCoworldLeaguePlayRoute: typeof SiteCoworldLeaguePlayRoute
  SiteCoworldLeaguePreviewRoute: typeof SiteCoworldLeaguePreviewRoute
  SiteCoworldLeagueStartRoute: typeof SiteCoworldLeagueStartRoute
  SiteCoworldLeagueSubmitRoute: typeof SiteCoworldLeagueSubmitRoute
  SiteCoworldLeagueIndexRoute: typeof SiteCoworldLeagueIndexRoute
  SiteCoworldLeaguePlayActivityRoute: typeof SiteCoworldLeaguePlayActivityRoute
  SiteCoworldLeaguePlayEpisodesRoute: typeof SiteCoworldLeaguePlayEpisodesRoute
  SiteCoworldLeaguePlayRequestsRoute: typeof SiteCoworldLeaguePlayRequestsRoute
}

const SiteCoworldLeagueRouteChildren: SiteCoworldLeagueRouteChildren = {
  SiteCoworldLeaguePlayRoute: SiteCoworldLeaguePlayRoute,
  SiteCoworldLeaguePreviewRoute: SiteCoworldLeaguePreviewRoute,
  SiteCoworldLeagueStartRoute: SiteCoworldLeagueStartRoute,
  SiteCoworldLeagueSubmitRoute: SiteCoworldLeagueSubmitRoute,
  SiteCoworldLeagueIndexRoute: SiteCoworldLeagueIndexRoute,
  SiteCoworldLeaguePlayActivityRoute: SiteCoworldLeaguePlayActivityRoute,
  SiteCoworldLeaguePlayEpisodesRoute: SiteCoworldLeaguePlayEpisodesRoute,
  SiteCoworldLeaguePlayRequestsRoute: SiteCoworldLeaguePlayRequestsRoute,
}

const SiteCoworldLeagueRouteWithChildren =
  SiteCoworldLeagueRoute._addFileChildren(SiteCoworldLeagueRouteChildren)

interface SiteCoworldRouteChildren {
  SiteCoworldLeagueRoute: typeof SiteCoworldLeagueRouteWithChildren
  SiteCoworldDeskRoute: typeof SiteCoworldDeskRoute
  SiteCoworldPlayRoute: typeof SiteCoworldPlayRoute
  SiteCoworldPreviewRoute: typeof SiteCoworldPreviewRoute
  SiteCoworldSearchRoute: typeof SiteCoworldSearchRoute
  SiteCoworldStartRoute: typeof SiteCoworldStartRoute
  SiteCoworldSubmitRoute: typeof SiteCoworldSubmitRoute
  SiteCoworldIndexRoute: typeof SiteCoworldIndexRoute
  SiteCoworldForumPostIdRoute: typeof SiteCoworldForumPostIdRoute
  SiteCoworldPlayActivityRoute: typeof SiteCoworldPlayActivityRoute
  SiteCoworldPlayEpisodesRoute: typeof SiteCoworldPlayEpisodesRoute
  SiteCoworldPlayRequestsRoute: typeof SiteCoworldPlayRequestsRoute
  SiteCoworldPreviewEditRoute: typeof SiteCoworldPreviewEditRoute
  SiteCoworldWikiSplatRoute: typeof SiteCoworldWikiSplatRoute
  SiteCoworldForumIndexRoute: typeof SiteCoworldForumIndexRoute
  SiteCoworldWikiIndexRoute: typeof SiteCoworldWikiIndexRoute
}

const SiteCoworldRouteChildren: SiteCoworldRouteChildren = {
  SiteCoworldLeagueRoute: SiteCoworldLeagueRouteWithChildren,
  SiteCoworldDeskRoute: SiteCoworldDeskRoute,
  SiteCoworldPlayRoute: SiteCoworldPlayRoute,
  SiteCoworldPreviewRoute: SiteCoworldPreviewRoute,
  SiteCoworldSearchRoute: SiteCoworldSearchRoute,
  SiteCoworldStartRoute: SiteCoworldStartRoute,
  SiteCoworldSubmitRoute: SiteCoworldSubmitRoute,
  SiteCoworldIndexRoute: SiteCoworldIndexRoute,
  SiteCoworldForumPostIdRoute: SiteCoworldForumPostIdRoute,
  SiteCoworldPlayActivityRoute: SiteCoworldPlayActivityRoute,
  SiteCoworldPlayEpisodesRoute: SiteCoworldPlayEpisodesRoute,
  SiteCoworldPlayRequestsRoute: SiteCoworldPlayRequestsRoute,
  SiteCoworldPreviewEditRoute: SiteCoworldPreviewEditRoute,
  SiteCoworldWikiSplatRoute: SiteCoworldWikiSplatRoute,
  SiteCoworldForumIndexRoute: SiteCoworldForumIndexRoute,
  SiteCoworldWikiIndexRoute: SiteCoworldWikiIndexRoute,
}

const SiteCoworldRouteWithChildren = SiteCoworldRoute._addFileChildren(
  SiteCoworldRouteChildren,
)

interface SiteAccountRouteChildren {
  SiteAccountAdvancedRoute: typeof SiteAccountAdvancedRoute
  SiteAccountCredentialsRoute: typeof SiteAccountCredentialsRoute
  SiteAccountIndexRoute: typeof SiteAccountIndexRoute
}

const SiteAccountRouteChildren: SiteAccountRouteChildren = {
  SiteAccountAdvancedRoute: SiteAccountAdvancedRoute,
  SiteAccountCredentialsRoute: SiteAccountCredentialsRoute,
  SiteAccountIndexRoute: SiteAccountIndexRoute,
}

const SiteAccountRouteWithChildren = SiteAccountRoute._addFileChildren(
  SiteAccountRouteChildren,
)

interface SiteCoworldsNameRunsRouteChildren {
  SiteCoworldsNameRunsRequestIdRoute: typeof SiteCoworldsNameRunsRequestIdRoute
  SiteCoworldsNameRunsNewRoute: typeof SiteCoworldsNameRunsNewRoute
}

const SiteCoworldsNameRunsRouteChildren: SiteCoworldsNameRunsRouteChildren = {
  SiteCoworldsNameRunsRequestIdRoute: SiteCoworldsNameRunsRequestIdRoute,
  SiteCoworldsNameRunsNewRoute: SiteCoworldsNameRunsNewRoute,
}

const SiteCoworldsNameRunsRouteWithChildren =
  SiteCoworldsNameRunsRoute._addFileChildren(SiteCoworldsNameRunsRouteChildren)

interface SiteCoworldsRouteChildren {
  SiteCoworldsIndexRoute: typeof SiteCoworldsIndexRoute
  SiteCoworldsNameManageRoute: typeof SiteCoworldsNameManageRoute
  SiteCoworldsNameRunsRoute: typeof SiteCoworldsNameRunsRouteWithChildren
  SiteCoworldsNameIndexRoute: typeof SiteCoworldsNameIndexRoute
}

const SiteCoworldsRouteChildren: SiteCoworldsRouteChildren = {
  SiteCoworldsIndexRoute: SiteCoworldsIndexRoute,
  SiteCoworldsNameManageRoute: SiteCoworldsNameManageRoute,
  SiteCoworldsNameRunsRoute: SiteCoworldsNameRunsRouteWithChildren,
  SiteCoworldsNameIndexRoute: SiteCoworldsNameIndexRoute,
}

const SiteCoworldsRouteWithChildren = SiteCoworldsRoute._addFileChildren(
  SiteCoworldsRouteChildren,
)

interface SitePoliciesRouteChildren {
  SitePoliciesPolicyIdRoute: typeof SitePoliciesPolicyIdRoute
  SitePoliciesIndexRoute: typeof SitePoliciesIndexRoute
  SitePoliciesVersionsPolicyVersionIdRoute: typeof SitePoliciesVersionsPolicyVersionIdRoute
}

const SitePoliciesRouteChildren: SitePoliciesRouteChildren = {
  SitePoliciesPolicyIdRoute: SitePoliciesPolicyIdRoute,
  SitePoliciesIndexRoute: SitePoliciesIndexRoute,
  SitePoliciesVersionsPolicyVersionIdRoute:
    SitePoliciesVersionsPolicyVersionIdRoute,
}

const SitePoliciesRouteWithChildren = SitePoliciesRoute._addFileChildren(
  SitePoliciesRouteChildren,
)

interface SiteUnlistedCoworldLeagueRouteChildren {
  SiteUnlistedCoworldLeaguePlayRoute: typeof SiteUnlistedCoworldLeaguePlayRoute
  SiteUnlistedCoworldLeaguePreviewRoute: typeof SiteUnlistedCoworldLeaguePreviewRoute
  SiteUnlistedCoworldLeagueStartRoute: typeof SiteUnlistedCoworldLeagueStartRoute
  SiteUnlistedCoworldLeagueSubmitRoute: typeof SiteUnlistedCoworldLeagueSubmitRoute
  SiteUnlistedCoworldLeagueIndexRoute: typeof SiteUnlistedCoworldLeagueIndexRoute
  SiteUnlistedCoworldLeaguePlayActivityRoute: typeof SiteUnlistedCoworldLeaguePlayActivityRoute
  SiteUnlistedCoworldLeaguePlayEpisodesRoute: typeof SiteUnlistedCoworldLeaguePlayEpisodesRoute
  SiteUnlistedCoworldLeaguePlayRequestsRoute: typeof SiteUnlistedCoworldLeaguePlayRequestsRoute
}

const SiteUnlistedCoworldLeagueRouteChildren: SiteUnlistedCoworldLeagueRouteChildren =
  {
    SiteUnlistedCoworldLeaguePlayRoute: SiteUnlistedCoworldLeaguePlayRoute,
    SiteUnlistedCoworldLeaguePreviewRoute:
      SiteUnlistedCoworldLeaguePreviewRoute,
    SiteUnlistedCoworldLeagueStartRoute: SiteUnlistedCoworldLeagueStartRoute,
    SiteUnlistedCoworldLeagueSubmitRoute: SiteUnlistedCoworldLeagueSubmitRoute,
    SiteUnlistedCoworldLeagueIndexRoute: SiteUnlistedCoworldLeagueIndexRoute,
    SiteUnlistedCoworldLeaguePlayActivityRoute:
      SiteUnlistedCoworldLeaguePlayActivityRoute,
    SiteUnlistedCoworldLeaguePlayEpisodesRoute:
      SiteUnlistedCoworldLeaguePlayEpisodesRoute,
    SiteUnlistedCoworldLeaguePlayRequestsRoute:
      SiteUnlistedCoworldLeaguePlayRequestsRoute,
  }

const SiteUnlistedCoworldLeagueRouteWithChildren =
  SiteUnlistedCoworldLeagueRoute._addFileChildren(
    SiteUnlistedCoworldLeagueRouteChildren,
  )

interface SiteUnlistedCoworldRouteChildren {
  SiteUnlistedCoworldLeagueRoute: typeof SiteUnlistedCoworldLeagueRouteWithChildren
  SiteUnlistedCoworldDeskRoute: typeof SiteUnlistedCoworldDeskRoute
  SiteUnlistedCoworldPlayRoute: typeof SiteUnlistedCoworldPlayRoute
  SiteUnlistedCoworldPreviewRoute: typeof SiteUnlistedCoworldPreviewRoute
  SiteUnlistedCoworldSearchRoute: typeof SiteUnlistedCoworldSearchRoute
  SiteUnlistedCoworldStartRoute: typeof SiteUnlistedCoworldStartRoute
  SiteUnlistedCoworldSubmitRoute: typeof SiteUnlistedCoworldSubmitRoute
  SiteUnlistedCoworldIndexRoute: typeof SiteUnlistedCoworldIndexRoute
  SiteUnlistedCoworldForumPostIdRoute: typeof SiteUnlistedCoworldForumPostIdRoute
  SiteUnlistedCoworldPlayActivityRoute: typeof SiteUnlistedCoworldPlayActivityRoute
  SiteUnlistedCoworldPlayEpisodesRoute: typeof SiteUnlistedCoworldPlayEpisodesRoute
  SiteUnlistedCoworldPlayRequestsRoute: typeof SiteUnlistedCoworldPlayRequestsRoute
  SiteUnlistedCoworldPreviewEditRoute: typeof SiteUnlistedCoworldPreviewEditRoute
  SiteUnlistedCoworldWikiSplatRoute: typeof SiteUnlistedCoworldWikiSplatRoute
  SiteUnlistedCoworldForumIndexRoute: typeof SiteUnlistedCoworldForumIndexRoute
  SiteUnlistedCoworldWikiIndexRoute: typeof SiteUnlistedCoworldWikiIndexRoute
}

const SiteUnlistedCoworldRouteChildren: SiteUnlistedCoworldRouteChildren = {
  SiteUnlistedCoworldLeagueRoute: SiteUnlistedCoworldLeagueRouteWithChildren,
  SiteUnlistedCoworldDeskRoute: SiteUnlistedCoworldDeskRoute,
  SiteUnlistedCoworldPlayRoute: SiteUnlistedCoworldPlayRoute,
  SiteUnlistedCoworldPreviewRoute: SiteUnlistedCoworldPreviewRoute,
  SiteUnlistedCoworldSearchRoute: SiteUnlistedCoworldSearchRoute,
  SiteUnlistedCoworldStartRoute: SiteUnlistedCoworldStartRoute,
  SiteUnlistedCoworldSubmitRoute: SiteUnlistedCoworldSubmitRoute,
  SiteUnlistedCoworldIndexRoute: SiteUnlistedCoworldIndexRoute,
  SiteUnlistedCoworldForumPostIdRoute: SiteUnlistedCoworldForumPostIdRoute,
  SiteUnlistedCoworldPlayActivityRoute: SiteUnlistedCoworldPlayActivityRoute,
  SiteUnlistedCoworldPlayEpisodesRoute: SiteUnlistedCoworldPlayEpisodesRoute,
  SiteUnlistedCoworldPlayRequestsRoute: SiteUnlistedCoworldPlayRequestsRoute,
  SiteUnlistedCoworldPreviewEditRoute: SiteUnlistedCoworldPreviewEditRoute,
  SiteUnlistedCoworldWikiSplatRoute: SiteUnlistedCoworldWikiSplatRoute,
  SiteUnlistedCoworldForumIndexRoute: SiteUnlistedCoworldForumIndexRoute,
  SiteUnlistedCoworldWikiIndexRoute: SiteUnlistedCoworldWikiIndexRoute,
}

const SiteUnlistedCoworldRouteWithChildren =
  SiteUnlistedCoworldRoute._addFileChildren(SiteUnlistedCoworldRouteChildren)

interface SiteRouteChildren {
  SiteCoworldRoute: typeof SiteCoworldRouteWithChildren
  SiteAccountRoute: typeof SiteAccountRouteWithChildren
  SiteBrowseRoute: typeof SiteBrowseRoute
  SiteCompleteProfileRoute: typeof SiteCompleteProfileRoute
  SiteCoworldsRoute: typeof SiteCoworldsRouteWithChildren
  SiteGetStartedRoute: typeof SiteGetStartedRoute
  SitePoliciesRoute: typeof SitePoliciesRouteWithChildren
  SiteSearchRoute: typeof SiteSearchRoute
  SiteSignInRoute: typeof SiteSignInRoute
  SiteWatchRoute: typeof SiteWatchRoute
  SiteCliAuthCompleteRoute: typeof SiteCliAuthCompleteRoute
  SiteEpisodesEpisodeIdRoute: typeof SiteEpisodesEpisodeIdRoute
  SiteExperienceRequestsRequestIdRoute: typeof SiteExperienceRequestsRequestIdRoute
  SiteForumPostIdRoute: typeof SiteForumPostIdRoute
  SiteGithubConnectRoute: typeof SiteGithubConnectRoute
  SiteLobbiesLobbyIdRoute: typeof SiteLobbiesLobbyIdRoute
  SitePlaySessionsSessionIdRoute: typeof SitePlaySessionsSessionIdRoute
  SitePlaySplatRoute: typeof SitePlaySplatRoute
  SitePlayersPlayerIdRoute: typeof SitePlayersPlayerIdRoute
  SitePreviewSplatRoute: typeof SitePreviewSplatRoute
  SiteReplaysCoworldIdRoute: typeof SiteReplaysCoworldIdRoute
  SiteTournamentsTournamentIdRoute: typeof SiteTournamentsTournamentIdRoute
  SiteUnlistedCoworldRoute: typeof SiteUnlistedCoworldRouteWithChildren
  SiteWikiSplatRoute: typeof SiteWikiSplatRoute
  SiteCliAuthIndexRoute: typeof SiteCliAuthIndexRoute
  SiteForumIndexRoute: typeof SiteForumIndexRoute
  SitePlayIndexRoute: typeof SitePlayIndexRoute
  SiteWikiIndexRoute: typeof SiteWikiIndexRoute
  SiteCoworldEpisodesEpisodeIdRoute: typeof SiteCoworldEpisodesEpisodeIdRoute
  SiteCoworldLobbiesLobbyIdRoute: typeof SiteCoworldLobbiesLobbyIdRoute
  SiteCoworldPlaySessionsSessionIdRoute: typeof SiteCoworldPlaySessionsSessionIdRoute
  SiteCoworldReportsReportSlugRoute: typeof SiteCoworldReportsReportSlugRoute
  SiteEpisodeRequestsRequestIdWatchRoute: typeof SiteEpisodeRequestsRequestIdWatchRoute
  SiteLeaguesLeagueIdSettingsRoute: typeof SiteLeaguesLeagueIdSettingsRoute
  SiteCoworldEpisodeRequestsRequestIdWatchRoute: typeof SiteCoworldEpisodeRequestsRequestIdWatchRoute
  SiteCoworldEpisodesEpisodeIdReplayRoute: typeof SiteCoworldEpisodesEpisodeIdReplayRoute
  SiteUnlistedCoworldEpisodesEpisodeIdRoute: typeof SiteUnlistedCoworldEpisodesEpisodeIdRoute
  SiteUnlistedCoworldLobbiesLobbyIdRoute: typeof SiteUnlistedCoworldLobbiesLobbyIdRoute
  SiteUnlistedCoworldPlaySessionsSessionIdRoute: typeof SiteUnlistedCoworldPlaySessionsSessionIdRoute
  SiteUnlistedCoworldReportsReportSlugRoute: typeof SiteUnlistedCoworldReportsReportSlugRoute
  SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute: typeof SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute
  SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute: typeof SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute
}

const SiteRouteChildren: SiteRouteChildren = {
  SiteCoworldRoute: SiteCoworldRouteWithChildren,
  SiteAccountRoute: SiteAccountRouteWithChildren,
  SiteBrowseRoute: SiteBrowseRoute,
  SiteCompleteProfileRoute: SiteCompleteProfileRoute,
  SiteCoworldsRoute: SiteCoworldsRouteWithChildren,
  SiteGetStartedRoute: SiteGetStartedRoute,
  SitePoliciesRoute: SitePoliciesRouteWithChildren,
  SiteSearchRoute: SiteSearchRoute,
  SiteSignInRoute: SiteSignInRoute,
  SiteWatchRoute: SiteWatchRoute,
  SiteCliAuthCompleteRoute: SiteCliAuthCompleteRoute,
  SiteEpisodesEpisodeIdRoute: SiteEpisodesEpisodeIdRoute,
  SiteExperienceRequestsRequestIdRoute: SiteExperienceRequestsRequestIdRoute,
  SiteForumPostIdRoute: SiteForumPostIdRoute,
  SiteGithubConnectRoute: SiteGithubConnectRoute,
  SiteLobbiesLobbyIdRoute: SiteLobbiesLobbyIdRoute,
  SitePlaySessionsSessionIdRoute: SitePlaySessionsSessionIdRoute,
  SitePlaySplatRoute: SitePlaySplatRoute,
  SitePlayersPlayerIdRoute: SitePlayersPlayerIdRoute,
  SitePreviewSplatRoute: SitePreviewSplatRoute,
  SiteReplaysCoworldIdRoute: SiteReplaysCoworldIdRoute,
  SiteTournamentsTournamentIdRoute: SiteTournamentsTournamentIdRoute,
  SiteUnlistedCoworldRoute: SiteUnlistedCoworldRouteWithChildren,
  SiteWikiSplatRoute: SiteWikiSplatRoute,
  SiteCliAuthIndexRoute: SiteCliAuthIndexRoute,
  SiteForumIndexRoute: SiteForumIndexRoute,
  SitePlayIndexRoute: SitePlayIndexRoute,
  SiteWikiIndexRoute: SiteWikiIndexRoute,
  SiteCoworldEpisodesEpisodeIdRoute: SiteCoworldEpisodesEpisodeIdRoute,
  SiteCoworldLobbiesLobbyIdRoute: SiteCoworldLobbiesLobbyIdRoute,
  SiteCoworldPlaySessionsSessionIdRoute: SiteCoworldPlaySessionsSessionIdRoute,
  SiteCoworldReportsReportSlugRoute: SiteCoworldReportsReportSlugRoute,
  SiteEpisodeRequestsRequestIdWatchRoute:
    SiteEpisodeRequestsRequestIdWatchRoute,
  SiteLeaguesLeagueIdSettingsRoute: SiteLeaguesLeagueIdSettingsRoute,
  SiteCoworldEpisodeRequestsRequestIdWatchRoute:
    SiteCoworldEpisodeRequestsRequestIdWatchRoute,
  SiteCoworldEpisodesEpisodeIdReplayRoute:
    SiteCoworldEpisodesEpisodeIdReplayRoute,
  SiteUnlistedCoworldEpisodesEpisodeIdRoute:
    SiteUnlistedCoworldEpisodesEpisodeIdRoute,
  SiteUnlistedCoworldLobbiesLobbyIdRoute:
    SiteUnlistedCoworldLobbiesLobbyIdRoute,
  SiteUnlistedCoworldPlaySessionsSessionIdRoute:
    SiteUnlistedCoworldPlaySessionsSessionIdRoute,
  SiteUnlistedCoworldReportsReportSlugRoute:
    SiteUnlistedCoworldReportsReportSlugRoute,
  SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute:
    SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute,
  SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute:
    SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute,
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

interface WorkspaceIdeNextRouteChildren {
  WorkspaceIdeNextIndexRoute: typeof WorkspaceIdeNextIndexRoute
  WorkspaceIdeNextSSessionIdRoute: typeof WorkspaceIdeNextSSessionIdRoute
}

const WorkspaceIdeNextRouteChildren: WorkspaceIdeNextRouteChildren = {
  WorkspaceIdeNextIndexRoute: WorkspaceIdeNextIndexRoute,
  WorkspaceIdeNextSSessionIdRoute: WorkspaceIdeNextSSessionIdRoute,
}

const WorkspaceIdeNextRouteWithChildren =
  WorkspaceIdeNextRoute._addFileChildren(WorkspaceIdeNextRouteChildren)

interface WorkspaceRouteChildren {
  WorkspaceIdeNextRoute: typeof WorkspaceIdeNextRouteWithChildren
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceIdeNextRoute: WorkspaceIdeNextRouteWithChildren,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  OfficeRoute: OfficeRouteWithChildren,
  SiteRoute: SiteRouteWithChildren,
  WorkspaceRoute: WorkspaceRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
